export default {
  services: {
    hero: {
      title: "Helping you grow your installation business",
      paragraph:
        "Cupidatat minim id magna ipsum sint dolor qui. Sunt sit in quis cupidatat mollit aute velit. Et labore commodo nulla aliqua proident mollit ullamco exercitation tempor. Sint aliqua anim nulla sunt mollit id pariatur in voluptate cillum. Eu voluptate tempor esse minim amet fugiat veniam occaecat aliqua.",
      "button-1": "Demander une démo",
      "button-2": "Démarrer maintenant",
    },
    "value-proposition": {
      "everything-you-need": "Everything you need",
      title: "The platform to manage your solar projects",
      paragraph:
        "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Maiores impedit perferendis suscipit eaque, iste dolor cupiditate blanditiis.",
      "key-value": {
        "team-management": {
          title: "Team management",
          description: "bla bla bla",
        },
        "digital-presentations": {
          title: "Digital presentations",
          description: "bla bla bla...",
        },
        administration: {
          title: "Administration",
          description: "Bla bla bla !",
        },
        "quotes-management": {
          title: "Quote management",
          description: "Bla bla bla ?",
        },
        "hardware-management": {
          title: "Hardware management",
          description: "bla bla bla ?!",
        },
        "calendar-management": {
          title: "Calendar management",
          description: "bla bla bla.",
        },
      },
    },
    stats: {
      "why-us": "Why us ?",
      title: "Get support to grow your installation business",
      paragraph:
        "Rhoncus sagittis risus arcu erat lectus bibendum. Ut in adipiscing quis in viverra tristique sem. Ornare feugiat viverra eleifend fusce orci in quis amet. Sit in et vitae tortor, massa. Dapibus laoreet amet lacus nibh integer quis. Eu vulputate diam sit tellus quis at.",
      "number-stats": {
        "founded-in": {
          stat: "2020",
          emphasis: "Founded",
          rest: "during first confinement.",
        },
        "installer-on-platform": {
          stat: "1400+",
          emphasis: "Local businesses",
          rest: "with us.",
        },
        servicing: {
          stat: "100000+",
          emphasis: "Administration services",
          rest: "per month.",
        },
        "projects-in-france": {
          stat: "200+ MW",
          emphasis: "Solar projects",
          rest: "made possible.",
        },
      },
    },
    testimonials: {},
    "service-block": {
      title: "The solutions that we propose",
      description: "Explore how to grow your business while saving time.",
      services: {
        "meet-new-customers": "Meet new customers",
        "automate-administration": "Automate the administrative process",
        "explore-digital": "Explore the digital",
      },
    },
    commitments: {
      "why-us": "L'informatique au service du photovoltaïque",
      title: "Nos engagements",
      paragraph:
        "La France est le seul pays en Europe qui a installé moins de kW de panneaux solaires cette année que l’année dernière. Les délais dus aux démarches administratives se comptent en plusieurs mois. Le progrès technique fait qu’une démarche de rupture est nécessaire. Nous vous aidons l'artisanat de France à gagner du temps pour mieux croître.",
      "key-values": {
        value1: {
          title:
            "Faciliter aux professionnels techniques l’exercice de leur cœur de métier.",
          description: "",
        },
        value2: {
          title:
            "Libérer enfin la filière photovoltaïque de l’éco-délinquance.",
          description: "",
        },
        value3: {
          title:
            "Proposer les services numériques de pointe aux artisans pour réduire leurs délais ainsi que coûts de commercialisation.",
          description: "",
        },
        value4: {
          title:
            "Renforcer l’indépendance de la filière par rapport aux grands groupes de sous-traitance et des plateformes contraignantes",
          description: ".",
        },
        value5: {
          title:
            "Valoriser les entreprises locales et le savoir-faire de proximité.",
          description: "",
        },
        value6: {
          title: "Réduire la fracture numérique qui se creuse dans notre pays.",
          description: "",
        },
      },
    },

    cta: {
      "start-using": "Start using our platform today.",
      paragraph:
        "Incididunt sint fugiat pariatur cupidatat consectetur sit cillum anim id veniam aliqua proident excepteur commodo do ea.",
      button: "Get started",
      "learn-more": "Learn more",
    },
  },

  "sales-widget": {
    kicker: "The all-in-one platform for solar + storage",
    "hero-title": "From first appointment to commissioning",
    subtitle:
      "Grow revenue and scale your business with homeowners and suppliers through collaborative project management assistance.",
    "bullet-1": "No subscription",
    "bullet-2": "No commitment",
    "bullet-3": "Fits into your workflows",
    "beat-competition": "Stay ahead of the competition",
    "sign-up": "Sign up",
    "title-first-half": "Design office",
    "title-second-half": "built for speed",
    "pv-magazine-citation":
      "\"Every step of a solar installation can be done collaboratively on the same digital tool.\"",
    "trusted-by": "They trust us",
    "ask-demo": "Request my demo",
    presentations: "Use cases",
    button: "Discover now",
    join: "Already 1400+ businesses",
    "you-should-earn": "You could earn",
    "gain-time": "Save time with Projetsolaire",
    for: "for",
    "projects-per-month": "projects per month",
    "per-month": "per month",
    hours: "hours",
    discount: "with a reduction of €{discount} per project",
    "how-cost-estimates-are-calculated": {
      button: "Learn how we estimate your costs",
      title: "How are your cost estimates calculated?",
    },
    "hours-per-project": "{hours} hours per full project file",
    "open-project-modal": {
      title: "How many projects per month?",
    },
    "open-charges-modal": {
      title: "How are your cost estimates calculated?",
      content:
        "<p>To estimate reductions in back-office workload, we look at typical processing times across the sales cycle for businesses similar to yours. Projetsolaire’s digital design office handles thousands of cases every month for <a class='text-blue-600 underline' target='_blank' href='https://www.projetsolaire.com/installer/case-studies'>hundreds</a> of solar companies.</p><p>We calculate your costs from the information you provide. You tell us how many projects you run per month; if you specify average processing time per project, you get a more precise estimate based on your workload.</p><p>In France, well over half of a PV quote’s value is not equipment. Non-field payroll costs are a large part of per-watt price. We use INSEE averages to estimate hourly back-office cost—the <a class='text-blue-600 underline' target='_blank' href='https://www.insee.fr/fr/metadonnees/pcs2003/categorieSocioprofessionnelleAgregee/5?champRecherche=false'>“employee”</a> category. Mean gross monthly pay in that category is €2,433 <a class='text-blue-600 underline' target='_blank' href='https://www.insee.fr/fr/statistiques/7707884#onglet-2'>(INSEE, 2022)</a>. Average annual hours are 1,603 <a class='text-blue-600 underline' target='_blank' href='https://www.insee.fr/fr/statistiques/7456897?sommaire=7456956'>(INSEE, 2022)</a>, about 133 hours per month. Hourly rate excluding employer charges is about €18.39—used as your back-office hourly cost, feeding into per-watt quoting.</p><p>From that we estimate your per-project cost without Projetsolaire, then multiply by your monthly project count.</p><p>Actual savings depend on many factors: project count, system sizes, real processing time, and how you use Projetsolaire’s à la carte services, as well as actual payroll in your admin team.</p><p>These figures are indicative only and are not a guarantee or valuation.</p>",
    },
    "open-config-modal": {
      title: "Tell us about your back office",
      subtitle: "Installation scale",
      residentialProject: "Residential projects",
      businessProject: "Commercial projects",
      form: {
        "form-description": "Average processing time per project",
        "form-subdescription": "Enter average hours per project.",
        "sale-time": {
          label: "Prospecting, travel, and appointments",
          description:
            "Study documents, non-conclusive visits, quotes and revisions, follow-ups, and closing.",
        },
        "admin-time": {
          label: "Administrative filing and follow-up (≈2 months)",
          description:
            "Technical graphics, submissions, completeness requests, and reminders.",
        },
        "crm-time": {
          label: "Back office, order admin, and customer care",
          description:
            "Case tracking, post-sale calls, organising and syncing files across tools.",
        },
      },
    },
    "update-estimate": "Update my estimate",
    "data-not-saved": "Information not saved",
    "information-not-saved": "Information not stored",
    card: {
      title: "Stay ahead of competitors",
      presentation: "Studies and quotes",
      administration: "Administrative",
      facturation: "Invoicing and follow-up",
      button: "Testimonials",
    },
  },
  "solutions-grid": {
    title: "Modular solutions built for speed",
    description:
      "Save hours and money on every installation with our collaborative, simple, and fast digital toolbox.",
    cards: {
      network: {
        title: "Installer and builder network",
        description:
          "Connect solar + storage project owners with photovoltaic professionals.",
      },
      sales: {
        title: "Sales assistance (PMO)",
        description:
          "Receive white-label clients, send quotes, and win new business.",
      },
      crm: {
        title: "CRM-ERP for site tracking",
        description:
          "Simplify scheduling with technical visits and reports on the mobile app.",
      },
      admin: {
        title: "Administrative management",
        description:
          "Automate mandatory paperwork. Full 360° customer support.",
      },
    },
  },

  directory: {
    department: {
      find: "Find",
      photovolatic: "solar installer",
      "near-you": "for your solar project near you",
      "desc-1":
        "For you, we have selected the best solar panel installers so your project goes smoothly with no surprises.",
      "desc-2":
        "Please select a department by clicking directly on the map or by entering below the name of the department or postal code.",
      placeholder: "Coded department",
      installers: "Installers",
      duration: "Estimated duration",
      "service-offer": "Services offered",
      certification: "Certification",
      title: "Department",
      search: "Search",
      autonomy: {
        week: "week",
        month: "month",
        hour: "hour",
        "for-life": "for life",
        title: "How to achieve solar autonomy?",
        description:
          "With these 7 steps, easily achieve solar autonomy, reduce your bills, and enjoy clean, sustainable energy.",
        step1: {
          title: "Choose my solar system",
          description:
            "Benefit from a study of your percentage of electric autonomy—see your potential savings.",
        },
        step2: {
          title: "Validate project feasibility",
          description:
            "Receive several complete and detailed proposals from RGE-certified solar installers.",
        },
        step3: {
          title: "Choose my tailor-made quote",
          description:
            "Meet the technician at your home for the technical feasibility assessment of your project specifications.",
        },
        step4: {
          title: "Invest in solar",
          description:
            "Have your investment supervised by checking the quote and the main contractor's insurance.",
        },
        step5: {
          title: "Complete the procedures",
          description:
            "Obtain planning permission from your town hall while complying with current standards.",
        },
        step6: {
          title: "Installation & commissioning",
          description:
            "Enhance the production of your solar installation connected to the electricity grid.",
        },
        step7: {
          title: "After-installation service",
          description:
            "Projetsolaire supports you even after your installation is set up, for the maintenance of your panels.",
        },
        stage: "Step",
      },
      hero: {
        department: {
          habitants: {
            title: "{population} inhabitants",
            description:
              "The department of {departmentName} has {population} inhabitants.",
          },
          "protected-areas": {
            title: "{numberHistoricalMonuments} historical monuments",
            description:
              "Number of protected areas in the department of {departmentName}",
          },
          rate: {
            title: "{averageIrradiance} sunshine",
            description:
              "This is the irradiance rate of the department of {departmentName}",
          },
        },
        "find-installers": "Find an installer in",

        "installer-verify": "Verified installer",
        certification: "Certification",
        "get-quote": "Get a quote",
        link: "This is my company",
      },
      metropole: "Metropolis",
      "drom-com": "DROM-COM",
      "other-installers": {
        title: "Solar installers near you",
        empty: {
          title: "No verified installers yet in your department",
          link: "I am a solar professional and want to appear in the directory",
        },
      },
      recommended: "Recommended",
      "installation-services": {
        title: "Service type",
        "solar-installation-business": "Commercial solar installation",
        "solar-installation-residential": "Residential solar installation",
        "heat-pump": "Heating",
        bess: "Battery energy storage system",
        "energy-audits": "Energy audits",
        "electric-vehicle-charging-station":
          "Electric vehicle charging station",
        hvac: "Air conditioning",
      },
      organization: {
        title: "Certifications",
        QUALITENR: {
          name: "QualitEnR",
        },
        QUALIBAT: {
          name: "Qualibat",
        },
        QUALIFELEC: {
          name: "Qualifelec",
        },
        OPQIBI: {
          name: "OPQIBI",
        },
        AFNOR: {
          name: "AFNOR",
        },
        LNE: {
          name: "LNE",
        },
        CERQUAL: {
          name: "CERQUAL",
        },
        CERTIBAT: {
          name: "Certibat",
        },
        TESLA: {
          name: "Tesla",
        },
      },
    },
    promises: {
      heading: "Our promise",
      title: "Digital technology at the service of solar energy for all of us",
      button: "Start your journey",
      description:
        "Your energy is a polluting dependency. We make it easier for you to access solar with storage.",
      "start-button": "Launch my solar project",
      "energy-expert-title": "Reduce the price of solar",
      "energy-expert-description":
        "A trained team to support you throughout your project",
      "estimate-project-title": "End eco-delinquency",
      "estimate-project-description":
        "Estimate your project by filling out our form and benefit from the best rates",
      "free-title": "Accelerate the energy transition",
      "free-description":
        "Projet Solaire supports you free of charge to build your project with the best craftsmen",
    },
    "learn-more": "Learn more",
    "made-by": "Made by",
    "read-more": "Read his story",
    expertise: {
      "project-of-the-week": {
        title: "Project of the week",
        description: "See the projects launched with projetsolaire",
      },
      department: "Department",
      "project-type": "Project type",
      "power-photovoltaic": "Photovoltaic power",
    },
    "gain-autonomy": {
      title: "Quickly gain solar autonomy",
      description:
        "The fastest way to complete your custom project. All you need is a single electricity bill. Finally access solar energy.",
      discovering: "I am discovering my solar potential",
    },
    profile: {
      "get-quote": "Get a personalized quote for your solar project!",
      "estimate-savings": "Estimate my savings",
      "free-and-without-engagement": "Free and without obligation",
      "we-call-you": "We call you back",
      "call-me-back": "Request a callback",
      "find-installer": "Find an installer",
      "book-appointment": "Book your appointment",
      "duplicate-email-enabled":
        "Your email is already associated with an existing account.",
      "duplicate-email-not-enabled":
        "Your email is associated with an existing but not yet activated account. Please check your inbox.",
      form: {
        "first-name": "First name",
        "last-name": "Last name",
        email: "Email",
        phone: "Phone number",
        "company-name": "Company name",
        siret: "SIRET",
        "name-of-representative": "Representative's last name",
        "first-name-of-representative": "Representative's first name",
        submit: "Send",
      },
    },
    hero: {
      title: "Companies of all sizes ready to support you",
      heading: "Local solar craftsman",
      description:
        "Start your solar project with a local installer for fast, reliable, and tailored service.",
      installers: "Installers",
      "installation-in": "Installation in",
      satisfaction: "Satisfaction",
      days: "days",
    },
    stats: {
      quick: {
        installers: {
          value: "1000+",
          label: "Installers on our network",
        },
        duration: {
          value: "7 days",
          label: "average installation duration",
        },
        satisfaction: {
          value: "98%",
          label: "customer satisfaction",
        },
      },
    },
  },

  administration: {
    hero: {
      administration: {
        title: "Administration",
        paragraph:
          "Simplifiez votre processus administratif avec projetsolaire.",
        button: "Get started",
        "request-a-demo": "Request a demo",
        "expert-at-service": "Experts at your service",
        "expert-at-service-desc":
          "Our team is here to listen to you and support you in your efforts.",
        "for-all-your-project-type": "For all your project types.",
        stp: "Save time and permissions",
        "filling-information": "Filling in the information is left to us to do",
        qas: "Quality and speed",
        "qas-desc":
          "Since 2020, our design office has built up unique know-how. Our expertise on thousands of files of all types allows us to overcome all issues. Our project managers are organized into teams and trained to meet all the obligations of the French administration. Our design office is led by electrical and construction engineers - who work side by side with our developers to design the innovative automations that have made our reputation.",
        tools: "Our tools at your disposal",
        "tools-desc":
          "Take advantage of all the tools and services that our solution offers for your administration from start to finish.",
        "next-level": "Want to move to the next level?",
        "save-time": "Save time",
        ryp: "Reduce your paperwork",
        "quality-service": "The quality of our service",
        "service-needs": "Service adapted to your needs",
        sws: "They are satisfied with our service",
        "urban-planning":
          "The keys to understanding urban planning in your city",
        "urban-planning-desc":
          "With projetsolaire, be informed in a few seconds of the regulations of your city, without the need for additional research.",
        "learn-more-service": "Learn more about our services",
        "lms-desc":
          "With our wide range of tools, you will find what you are looking for thanks to our A to Z construction site management solution.",
        "need-clarification": "Need clarification?",
        "manage-service-title": "Easily manage your construction sites",
        "manage-service-desc":
          "Since 2020, our design office has built a deep expertise and recognized know-how. Accelerate your processes with our automations and your all-in-one construction site management platform.",
        tabs: {
          "on-the-roof": "On the roof",
          "on-the-ground": "On the ground",
          "on-a-carport": "On a carport",
          "on-a-pergola": "On a pergola",
          "on-a-roof-terrace": "On a roof terrace",
          "solar-tile": "Solar tile",
          "follow-up": "Follow up",
          "invite-your-customers": "Invite your customers",
          "request-for-completeness": "Request for completeness",
          reminder: "Reminder",
          "problem-follow-up": "Problem follow-up",
          "residential-tab-title": "For residential construction sites",
          "business-tab-title": "For tertiary construction sites",
        },
        steps: {
          step1:
            "Complete the information via mobile during the technical visit.",
          step2: "We send your file directly to the town hall within 48 hours.",
          step3:
            "We manage the processing of the file and follow up with the town halls.",
          step4:
            "You receive your town hall approval, urban planning permit, and compliance.",
        },

        contact: "Contact us",
        "appointment-desc":
          "Make an appointment with us to see together how we can simplify your organization and help you grow.",
        "get-in-touch": "Get in touch",
        "permission-title": "Save hours on every administrative file",
        "permission-desc":
          "Speed up your processes to reduce delays on your projects. Hundreds of installers already trust us.",
        "permission-title-2":
          "Eliminate weeks of delay on every administrative file",
        "permission-desc-2":
          "Speed up your processes to gain hours on your projects. Dozens of developers already trust us.",
        "management-title": "Collaborative, fast, and intuitive management",
        "management-desc":
          "Equip every member of your team with a powerful software for the execution and tracking of your projects.",
        consular: {
          residential: {
            first: "SC 144 (A or B or C)",
            second: "Electrical single-line diagram",
            third: "Battery storage (Violet)",
            title: "Visa requests for the Consuel Attestation",
            description:
              "Carrying out all procedures with the Consuel for your photovoltaic system. Obtaining conformity certificates - blue or violet.",
          },
          business: {
            first: "SC 144 (A or B or C)",
            second: "Electrical single-line diagram",
            third: "Attestation S21",
            title: "Control office and Consuel visa",
            description:
              "Carrying out all procedures with the Consuel for your photovoltaic system. Obtaining conformity certificates - blue or violet.",
          },
        },
        urbanPlanning: {
          residential: {
            first: "Prior Declarations",
            second: "Building Permit",
            third: "Friendly Appeal and DAACT",
            title: "Requests for Urban Planning Permissions",
            description:
              "The completion of the urban planning process for your photovoltaic system with local institutions, as well as ABF, CAUE, regional parks, etc.",
          },
          business: {
            first: "Prior Declarations 'Small Ground'",
            second: "Building Permit and Architect",
            third: "Bailiff's Report and DAACT",
            title: "Requests for Urban Planning Permissions",
            description:
              "The completion of the urban planning process for your photovoltaic system with local institutions, as well as ABF, CAUE, regional parks, etc.",
          },
        },
        connections: {
          residential: {
            first: "Enedis or local utility",
            second: "EDF Purchase Obligation or CACSI or ARPE",
            third: "Virtual battery",
            title: "Connection requests",
            description:
              "Carrying out the connection procedures for your photovoltaic system with the distribution network operator and a co-contractor, up to 500 kVA.",
          },
          business: {
            first: "Enedis or local utility",
            second: "EDF Obligation to Purchase or ARPE",
            third: "Collective self-consumption",
            title: "Connection requests in LV or HTA",
            description:
              "Carrying out the connection procedures for your photovoltaic system with the distribution network operator and a co-contractor, up to 500 kVA.",
          },
        },
        "service-client-360": "360° Customer Service",
        "service-client-360-desc":
          "Keep control with our multi-channel customer service, available all year round.",
        whatsNew: {
          title: "What's New?",
          tabs: {
            "mobile-app": "Mobile App",
            aos: "AOS",
            pvsyst: "PVsyst site analysis",
          },
          "mobile-app": {
            heading: "Manage your solar projects in the field",
            description:
              "The Projetsolaire Installer app gives your team real-time access to project tasks, documentation, photos and status updates right from the job site.",
          },
          aos: {
            heading: "Secure your feed-in tariff through a competitive auction",
            description:
              "Participate in the AOS auction process to obtain a regulated feed-in tariff. Submit compliant bids, compete transparently, and secure long-term energy revenue under official frameworks.",
            features: {
              feature1: "Competitive auction-based pricing",
              feature2: "Regulated feed-in tariff allocation",
              feature3: "Transparent selection process",
              feature4: "Long-term revenue visibility",
            },
          },
          pvsyst: {
            heading: "Bankable PV performance modelling with PVsyst",
            description:
              "Validate your project with professional PVsyst simulations. Our experts analyze site conditions, system design, losses, and energy yield to produce bankable performance reports aligned with lender and regulatory expectations.",
            features: {
              feature1: "Energy yield & PR calculations",
              feature2: "Shading and horizon analysis",
              feature3: "System losses breakdown",
              feature4: "Compliance-ready PVsyst reports",
            },
          },
        },
        modules: {
          title: "Our specialized administration modules",
          description:
            "Go beyond the basics with expert and custom operational services each designed to handle complex project requirements.",
          items: {
            aosAuction: {
              title: "AOS auction management",
              description:
                "Navigate the CRE feed-in tariff auction process with expert guidance.",
            },
            pvsystAnalysis: {
              title: "PVsyst site analysis",
              description: "Detailed yield studies and bankable production forecasts.",
            },
            archeliosDesign: {
              title: "Archelios design studies",
              description:
                "Comprehensive system design and optimization reports.",
            },
            permitEvaluation: {
              title: "Permit evaluation",
              description:
                "Pre-submission risk analysis and feasibility assessment.",
            },
            architectServices: {
              title: "Architect Services",
              description:
                "ABF submissions and architectural integration studies.",
            },
            groundMountDesign: {
              title: "Ground Mount Design",
              description:
                "Structural engineering for ground-mounted installations.",
            },
            bessApplications: {
              title: "BESS applications",
              description:
                "Battery storage permitting and grid integration.",
            },
            collectiveSelfConsumption: {
              title: "Collective Self-Consumption",
              description:
                "Multi-party energy sharing configuration and compliance.",
            },
            caisseDepots: {
              title: "Caisse des Dépôts",
              description:
                "Bank security deposit management and coordination.",
            },
          },
          buttons: {
            talkToExpert: "Talk to an expert",
            requestQuote: "Request a quote",
          },
        },
        managementTabs: {
          "visite-technique": "Technical visit",
          "envois-48-heures": "Shipped within 48 hours",
          "suivi-daté-en-temps-reel": "Real-time dated tracking",
          "demande-de-pieces": "Request for documents",
          relances: "Follow-ups",
          "visite-technique-title": "Mobile VT Assistance",
          "envois-48-heures-title": "Large-scale management",
          "suivi-daté-en-temps-reel-title": "Total transparency",
          "demande-de-pieces-title": "Simplified organization",
          "relances-title": "Accelerated processing",
          "visite-technique-desc":
            "Your technical sales representatives can easily upload photos and information on the go.",
          "envois-48-heures-desc":
            "Our pioneering automations and robots generate documents and fill out online forms.",
          "suivi-daté-en-temps-reel-desc":
            "Your secretariat can quickly start and track the progress of procedures on the same software.",
          "demande-de-pieces-desc":
            "Our design office processes requests for additional documents to unblock files.",
          "relances-desc":
            "Our project managers follow up with administrative bodies to reduce processing times.",
        },
        "solutions-title": "On-demand and tailored solutions",
        "solutions-desc":
          "An automated, all-in-one management of all your photovoltaic operations by a single point of contact.",
        "solutions-orange": "No subscription. No commitment.",
        breadcrumb: {
          administration: "Sizing",
          "autorisation-urbanisme": "Urban Planning Authorization",
          "demande-de-raccordement": "Connection Request",
          "demande-consuel": "Consul visa",
        },
        navigate: {
          title: "Administrative modules",
        },
        "procedure-title": "Administrative procedures",
        expertAtService: {
          "know-how-since": "Expertise since 2020",
          "know-how-since-desc": "A unique expertise and large-scale support.",
          "100-online": "100% online",
          "100-online-desc":
            "A fully online and mobile experience for maximum efficiency.",
          "speed-quality": "Speed and quality",
          "speed-quality-desc":
            "Thanks to an innovative and recognized automation process.",
        },
      },
    },
    "value-propositions": {
      "why-us": "Why us?",
      title: "All in one platform",
      "paragraph-1":
        "Dotez chaque membre de votre équipe d'un puissant logiciel pour la réalisation et le suivi de vos chantiers. L'outil informatique réduit vos délais, et permet à tous d’y voir plus clair.",
      "paragraph-2":
        "Vos commerciaux peuvent facilement télécharger les photos et documents sur votre compte.",
      "paragraph-3":
        "Votre secrétariat peut rapidement lancer puis suivre le déroulement des démarches sur le même logiciel.",
      "key-values": {
        value1: {
          title: "Wow cool stuff",
          description: "Explication here",
        },
        value2: {
          title: "Wow cool stuff",
          description: "Explication here",
        },
        value3: {
          title: "Wow cool stuff",
          description: "Explication here",
        },
        value4: {
          title: "Wow cool stuff",
          description: "Explication here",
        },
        value5: {
          title: "Wow cool stuff",
          description: "Explication here",
        },
        value6: {
          title: "Wow cool stuff",
          description: "Explication here",
        },
        value7: {
          title: "Wow cool stuff",
          description: "Explication here",
        },
        value8: {
          title: "Wow cool stuff",
          description: "Explication here",
        },
      },
    },
    products: {
      title: "Our services",
      paragraph:
        "Lorem ipsum dolor sit amet consect adipisicing elit. Possimus magnam voluptatum cupiditate veritatis in accusamus quisquam.",
      "requests-for-urban-planning-authorizations": {
        title: "Demandes d'autorisations d’urbanisme",
        subtitle:
          "La réalisation de la démarche d’urbanisme pour votre système photovoltaïque auprès de l’institution locale compétente.",
        "paragraph-1":
          "Dématérialisation des dossiers de déclaration préalable (ou permis de construire) grâce à l’API du Géoportail et l’utilisation systématique de guichet unique.",
        "paragraph-2":
          "Obtention de non-opposition, en PLU ou RNU. Envoi puis suivi des dossiers, avec preuves de dépôt et avis de réception des lettres recommandées. Relances matinales des mairies par téléphone.",
        "paragraph-3":
          "Interlocution avec Bâtiments de France (ABF), parcs régionaux, et autres autorités jusqu’à l’attestation de non-opposition à la conformité.",
      },
      "request-for-enedis": {
        title: "Demande de Raccordement",
        subtitle:
          "La réalisation de toutes les démarches de raccordement de votre système photovoltaïque auprès du réseau électrique Enedis et d'un cocontractant.",
        "paragraph-1":
          "Obtention de PDR ou PTF, CRAE ou CAE pour production d'électricité solaire (ou augmentation de puissance). Obtention aussi de la simulation du prix du devis Enedis selon le barème de facturation.",
        "paragraph-2":
          "Envoi et relance  Relance et suivi de l’avancement des dossiers par messagerie Enedis.",
        "paragraph-3":
          "Inclus aussi l’obtention EDF OA pour votre client, ou bien la démarche avec un co-contractant auprès de tous les fournisseurs de batterie virtuelle (Urban Solar Energy, MyLight150, JPME).",
      },
      "requests-for-consuel": {
        title: "Visa Consuel",
        subtitle:
          "La réalisation de toutes les démarches auprès du Consuel pour votre système photovoltaïque. Obtention des attestations de conformité.",
        "paragraph-1":
          "La réalisation de la fiche de collecte, du SC 144 (A/B) et du schéma électrique unifilaire auprès du Consuel pour votre système photovoltaïque. Gestion et suivi du dossier jusqu’à l’obtention pour mise en service de l’Attestation de Conformité « Bleu » (n°15523*01). Création et Test de l’attestation. Prévention de l’inspection du Consuel et planification de la visite.",
        "paragraph-2":
          "Avertissement : service exclut l’achat des d’Attestations de Conformité (AC). Le service numérique n’est à ce jour pas connecté au compte Monespaceconsuel.com",
      },
    },
    "new-pricing": {
      pricing: "Pricing",
      title: "Pricing plans for teams of all sizes",
      paragraph:
        "Choose an affordable plan that’s packed with the best features for engaging your audience, creating customer loyalty, and driving sales.",
      "producer-size": "Producer size",
      option: {
        "small-producer": "Small producer",
        "large-producer": "Large producer",
      },
      "buy-plan": "Buy plan",

      "price-card": {
        "requests-for-urban": {
          title: "Demandes d'autorisations d'Urbanisme",
          price: {
            small: "149€HT",
            big: "249€HT",
          },
          features: {
            feat1: "feature1",
            feat2: "feature2",
            feat3: "feature3",
            feat4: "feature4",
          },
          description:
            "La réalisation de la démarche d’urbanisme pour votre système photovoltaïque auprès de l’institution locale compétente. Dématérialisation des demandes grâce à l’API du Géoportail et l’utilisation systématique de guichet unique. Obtention de non-opposition de déclaration préalable ou permis de construire, en PLU ou RNU. Envoi puis suivi des dossiers, avec preuves de dépôt et avis de réception des lettres recommandées. Interlocution avec Bâtiments de France (ABF), parcs régionaux, et autres autorités jusqu’à l’attestation de non-opposition à la conformité.",
        },
        "requests-for-enedis": {
          title: "Demandes de raccordement",
          price: {
            small: "99€HT",
            big: "699€HT",
          },
          features: {
            feat1: "feature1",
            feat2: "feature2",
            feat3: "feature3",
            feat4: "feature4",
          },
          description:
            "La réalisation de toutes les démarches de raccordement de votre système photovoltaïque auprès du réseau électrique public, Enedis. Obtention de PDR ou PTF, CRAE ou CAE. Obtention de la simulation du prix du devis Enedis selon le barème de facturation. Relance et suivi de l’avancement des dossiers par messagerie Enedis. Inclus aussi l’obtention EDF OA pour votre client, ou bien la démarche avec un co-contractant auprès de tous les fournisseurs de batterie virtuelle (Urban Solar Energy, MyLight150, JPME)..",
        },
        "requests-for-consuel": {
          title: "Demandes de Visa Consuel",
          price: {
            small: "49€HT",
            big: "99€HT",
          },
          features: {
            feat1: "feature1",
            feat2: "feature2",
            feat3: "feature3",
            feat4: "feature4",
          },
          description:
            "La réalisation de la fiche de collecte, du SC-144 (A/B/C) et du schéma électrique unifilaire auprès du Consuel pour votre système photovoltaïque. Gestion et suivi du dossier jusqu’à l’obtention pour mise en service de l’Attestation de Conformité « Bleu » (n°15523*01). Création et Test de l’attestation. Prévention de l’inspection du Consuel et planification de la visite.",
        },
        package: {
          title: "Package",
          price: {
            small: "249€HT",
            big: "999€HT",
          },
          features: {
            feat1: "Unlimited products",
            feat2: "Unlimited subscribers",
            feat3: "Advanced analytics",
          },
          description:
            "La réalisation de l’ensemble des démarches administratives pour particuliers – d’autorisations d’urbanisme, Enedis, Visa Consuel, EDF OA ou batterie virtuelle, jusqu’à la mise en service.",
        },
      },
    },
    cta: {
      title: "Externalise your administration today.",
      paragraph:
        "Ac euismod vel sit maecenas id pellentesque eu sed consectetur. Malesuada adipiscing sagittis vel nulla.",
      button: "Get started",
      "learn-more": "Learn more",
    },
  },
  "digital-sales-tools": {
    hero: {
      interested: "Interested ?",
      "request-a-demo": "Request a demo",
      title: "A better way to present to your client",
      paragraph:
        "Esse id magna consectetur fugiat non dolor in ad laboris magna laborum ea consequat. Nisi irure aliquip nisi adipisicing veniam voluptate id. In veniam incididunt ex veniam adipisicing sit.",
      button: "Get started",
      "learn-more": "Learn more",
      animation: {
        intro: {
          welcome: "Bienvenue",
        },
        production: {
          title: "Annual production",
          paragraph:
            "Votre potentielle production d'électricité solaire est déterminée en fonction du nombre et de la puissance (en kWc) de vos panneaux solaires,ainsi que de leurs rendements énergétiques (en kWh/kWc).",
        },
        consumption: {
          title: "Consommation annuel",
          paragraph:
            "Votre consommation annuelle d'électricité est déterminée en fonction de la quantité d'électricité que vous utilisez, mesurée en kilowattheures (kWh).Cela dépend de vos habitudes de consommation.",
        },
        system: {
          title: "Mon système solaire",
          paragraph:
            "Nous vous réalisons votre projet solaire. Voici votre bien actuel sans panneaux photovoltaïques.",
          value: {
            "technical-specs": {
              title: "Cahier de charges",
              value: "16 kWc",
            },
            type: {
              title: "Type",
              value: "Classique",
            },
            "cellular-photovoltaique": {
              title: "Cahier de charges",
              value: "Monocrystallins",
            },
            inverters: {
              title: "Onduleur",
              value: "Micro-ondeleurs",
            },
            "manufacturer-warranty": {
              title: "Guarantie de fabricant",
              value: "25 ans",
            },
          },
        },
      },
    },
    configurable: {
      styling: {
        title: "Pick you companies branding",
        paragraph:
          "Want to personalise your clients presentations to your brands colour scheme? No problem!",
      },
    },

    "value-proposition": {
      "everything-you-need": "Everything you need",
      title: "No server? No problem.",
      paragraph:
        "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Maiores impedit perferendis suscipit eaque, iste dolor cupiditate blanditiis.",
      "key-value": {
        a: {
          title: "lidar",
          description: "bla bla bla",
        },
        b: {
          title: "hourly",
          description: "bla bla bla...",
        },
        c: {
          title: "your bill",
          description: "Bla bla bla !",
        },
      },
    },
    features: {
      a: {
        title: "Stay on top of customer support",
        paragraph:
          "Accédez à la courbe de charge réelle du propriétaire. Notre étude technico-financière sur 25 ans repose sur les mesures horaires (en kWh). L’historique de consommation est obtenu directement depuis le compteur Linky d'Enedis. Cette précision technique permet de calculer l'autoconsommation électrique heure par heure.",
        paragraph2: "projetsolaire :",
        paragraph3: "une entité référencée auprès d'Enedis",
        button: "Get started",
      },
      b: {
        title: "Better understand your customers",
        paragraph:
          "Semper curabitur ullamcorper posuere nunc sed. Ornare iaculis bibendum malesuada faucibus lacinia porttitor. Pulvinar laoreet sagittis viverra duis. In venenatis sem arcu pretium pharetra at. Lectus viverra dui tellus ornare pharetra.",
        button: "Get started",
      },
      c: {
        title: "Stay on top of customer support",
        paragraph:
          "Semper curabitur ullamcorper posuere nunc sed. Ornare iaculis bibendum malesuada faucibus lacinia porttitor. Pulvinar laoreet sagittis viverra duis. In venenatis sem arcu pretium pharetra at. Lectus viverra dui tellus ornare pharetra.",
        button: "Get started",
      },
      d: {
        title: "Stay on top of customer support",
        paragraph:
          "Semper curabitur ullamcorper posuere nunc sed. Ornare iaculis bibendum malesuada faucibus lacinia porttitor. Pulvinar laoreet sagittis viverra duis. In venenatis sem arcu pretium pharetra at. Lectus viverra dui tellus ornare pharetra.",
        button: "Get started",
      },
      e: {
        title: "Better understand your customers",
        paragraph:
          "Semper curabitur ullamcorper posuere nunc sed. Ornare iaculis bibendum malesuada faucibus lacinia porttitor. Pulvinar laoreet sagittis viverra duis. In venenatis sem arcu pretium pharetra at. Lectus viverra dui tellus ornare pharetra.",
        button: "Get started",
      },
      f: {
        title: "Stay on top of customer support",
        paragraph:
          "Semper curabitur ullamcorper posuere nunc sed. Ornare iaculis bibendum malesuada faucibus lacinia porttitor. Pulvinar laoreet sagittis viverra duis. In venenatis sem arcu pretium pharetra at. Lectus viverra dui tellus ornare pharetra.",
        button: "Get started",
      },
    },
    pricing: {
      title: "Simple pay as you go pricing",
      paragraph:
        "If you're not satisfied, contact us within the first 14 days and we'll send you a full refund.",
      "on-card": {
        title: "Presentation",
        paragraph:
          "Lorem ipsum dolor sit amet consect etur adipisicing elit. Itaque amet indis perferendis blanditiis repellendus etur quidem assumenda.",
        "what-included": "What's included",
        features: {
          feat1: "Digital web link to share with client",
          feat2: "Up to 3x changes can be requested",
          feat3: "Team member access",
          feat4: "Customisable slides",
        },
        "pay-as-you-go": "Pay as you go",
        "price-big": "100 €",
        "price-small": "Starting at",
        "join-waiting-list": "Learn about our membership policy",
        button: "Get started",
        "free-sample": "Get a free sample",
      },
    },
    "help-center": {
      title: "Need help getting started ?",
      paragraph:
        "Incididunt sint fugiat pariatur cupidatat consectetur sit cillum anim id veniam aliqua proident excepteur commodo do ea.",
      button: "Read our docs",
      "request-a-demo": "Request a demo",
    },
  },

  quote: {
    hero: {
      title: {
        before: "Sales",
        gradient: "Sales",
        after: "-integrated quoting that moves with your workflow",
      },
      description:
        "Attach quotes directly to presentations, issue them during or after calls, and collect signatures all without leaving your sales environment or switching to external tools.",
      button: {
        demo: "Book a demo",
        "instant-quote": "Get instant quote",
      },
      cards: {
        agreement: {
          title: "Customer Agreement",
          "sign-here": "Sign here",
        },
        quote: {
          company: "Solar Solutions Inc",
          number: "Quote #1029",
          status: "Draft",
          item1: "Solar panel system (5kW)",
          price1: "$15,000",
          item2: "Installation & setup",
          price2: "$3,500",
          item3: "Warranty (10 years)",
          price3: "$800",
          total: "Total",
          "total-price": "$19,300",
          button: {
            send: "Send for e-signature",
            preview: "Preview",
          },
          "auto-saved": "Auto-saved",
        },
        invoice: {
          title: "Invoice",
          "total-due": "Total Due",
          amount: "$15,200",
          button: "Pay now",
        },
      },
    },
    workflow: {
      title: "From presentation to payment in one seamless flow",
      subtitle: "Elevate your customer experience with a branded portal solution",
      cards: {
        card1: {
          title: "Attach to presentation",
          description: "Attach a quote directly to your sales presentation",
        },
        card2: {
          title: "Customize quote",
          description: "Edit pricing & branding with real-time preview",
        },
        card3: {
          title: "Send for E-signature",
          description: "Send digitally for signature without leaving the system",
        },
        card4: {
          title: "Payment/approval",
          description: "Receive approval and payment seamlessly",
        },
      },
    },
    features: {
      title: "Create and send quotes in seconds",
      description: "You already have a solar opportunity. Residential, commercial, or industrial you define the scope, requirements, and time line.",
      features: {
        feature1: "Build line items quickly with preset templates",
        feature2: "Instant calculations and professional formatting",
        feature3: "Send directly to customer with one click",
      },
      quoteCard: {
        title: "New Quote",
        number: "Quote #1025",
        tableHeaders: {
          article: "Item",
          quantity: "Qty",
          price: "Price",
          total: "Total",
        },
        items: {
          item1: {
            article: "Solar Panel - 400W",
            price: "$350",
            total: "$7,000",
          },
          item2: {
            article: "Inverter System",
            price: "$4,500",
            total: "$4,500",
          },
          item3: {
            article: "Installation & Setup",
            price: "$4,500",
            total: "$4,500",
          },
        },
        summary: {
          subtotalLabel: "Subtotal",
          subtotal: "$14,700",
          taxLabel: "Tax (8%)",
          tax: "$1,176",
          totalLabel: "Total",
          total: "$15,876",
        },
        buttons: {
          saveDraft: "Save draft",
          sendQuote: "Send quote",
        },
      },
    },
    customize: {
      title: "Customise every quote to match your sales needs",
      description: "Attach the right documents automatically technical specs, VAT forms, and custom terms so every quote is complete and compliant from day one.",
      features: {
        feature1: {
          title: "Automated document attachment",
          description: "Technical sheets, VAT reduction forms, and custom T&C attach automatically based on project type and equipment",
        },
        feature2: {
          title: "Editable pricing & items",
          description: "Adjust line items, quantities, and pricing on the fly without breaking your document flow",
        },
        feature3: {
          title: "White-label branding",
          description: "Upload your logo and choose your brand colors to showcase your professionalism when it matters",
        },
      },
      quoteCard: {
        company: {
          title: "Your company",
          name: "Solar Solutions",
        },
        number: "Quote #1025",
        summary: {
          equipmentLabel: "Equipment and materials",
          equipmentTotal: "$18,500",
          installationLabel: "Installation services",
          installationTotal: "$4,200",
          totalLabel: "Total",
          grandTotal: "$22,700",
        },
        documents: {
          title: "Attached documents",
          document1: {
            title: "SunPower Technical Spec Sheet",
            description: "Panel specifications & warranty",
            size: "PDF • 2.4 MB",
          },
          document2: {
            title: "VAT reduction application form",
            description: "Pre-filled for customer signature",
            size: "PDF • 850 KB",
          },
          document3: {
            title: "Terms & Conditions",
            description: "Your standard residential T&C",
            size: "PDF • 320 KB",
          },
          addButton: "Add another document",
        },
      },
    },
    billing: {
      title: "Simple billing when you need it",
      description: "Not everyone needs invoicing software, but when you do need to collect payment, we make it seamless. Optional, secure, and built right into the quote flow.",
      features: {
        feature1: {
          title: "Online payments",
          description: "Accept cards and bank transfers securely",
        },
        feature2: {
          title: "Secure checkout",
          description: "PCI-compliant payment processing",
        },
        feature3: {
          title: "Invoice generation",
          description: "Automatic receipts and documentation",
        },
      },
      invoiceCard: {
        title: "Invoice",
        number: "Quote #1025",
        dueOnAcceptance: "Due on acceptance",
        summary: {
          equipmentLabel: "Equipment & Materials",
          equipmentTotal: "$18,500",
          installationLabel: "Installation Services",
          installationTotal: "$4,200",
          totalLabel: "Total amount",
          grandTotal: "$22,700",
        },
        buttons: {
          payWithCard: "Pay with card",
          bankTransfer: "Bank transfer",
        },
      },
    },
    roles: {
      title: "Built for every role in your team",
      subtitle: "From lead generation to final installation",
      roles: {
        role1: {
          title: "Sales Representative",
          description: "Embed instant quote calculators on landing pages to capture leads with ballpark pricing that converts browsers into qualified prospects.",
        },
        role2: {
          title: "Marketing Team",
          description: "Embed instant quote calculators on landing pages to capture leads with ballpark pricing that converts browsers into qualified prospects.",
        },
        role3: {
          title: "Installation Team",
          description: "Collect final signatures on-site before beginning work, verify scope changes, and ensure everyone is aligned before installation starts.",
        },
      },
    },
    comparison: {
      title: "Built for winning sales teams",
      subtitle: "Built for effective sales teams that don't have time with paperwork",
      traditional: {
        title: "Traditional Billing",
        features: {
          feature1: {
            title: "Invoice-first",
            description: "Built around billing after work is done",
          },
          feature2: {
            title: "Accounting-driven",
            description: "Focused on bookkeeping and reconciliation",
          },
          feature3: {
            title: "Post-sale only",
            description: "Separate from the sales process",
          },
          feature4: {
            title: "Complex setup",
            description: "Requires extensive configuration",
          },
          feature5: {
            title: "External tools needed",
            description: "Requires integrations with CRM and sales tools",
          },
        },
      },
      simplified: {
        title: "Simplified quotes",
        features: {
          feature1: {
            title: "Sales-first",
            description: "Built for proposals and pre-sale quotes",
          },
          feature2: {
            title: "Proposal-driven",
            description: "Designed to close deals, not track expenses",
          },
          feature3: {
            title: "From lead to signature",
            description: "Complete sales workflow integration",
          },
          feature4: {
            title: "Instant setup",
            description: "Start sending quotes in minutes",
          },
          feature5: {
            title: "All-in-one workflow",
            description: "No external tools or context switching",
          },
        },
      },
    },
    cta: {
      title: {
        before: "Ready to ",
        gradient: "streamline",
        after: " your quote process?",
      },
      description: "Join energy companies using Simplified Energy to close deals faster with sales-integrated quoting.",
      features: {
        feature1: "No credit card required",
        feature2: "Free instant quotes feature",
        feature3: "Setup in minutes",
      },
      button: "Book a demo",
    },
  },

  tender: {
    system: {
      datasheet: {
        title: "Fiche technique",
        paragraph: "Vous trouverez ci-dessous les détails techniques du projet",
        systemepower: "Puissance du système",
        numberpanels: "Nombre de panneau",
        panelstype: "Type de panneaux",
        roofheight: "Hauteur du toit",
        roofstructure: "Structure du toit",
        roofmaterials: "Matériaux du toit",
        roofaccessibility: "Accessibilité du toit",
        panelpreference: "Préférence panneau",
        quotenumber: "Nombre de devis reçu",
        Typenetworkconnection: "Type de branchement",
        powernetworkkva: "Puissance de la Souscription du réseau en kVa",
      },
    },
  },

  "case-studies": {
    "logo-cloud": {
      text: "Over 600 installers use our tools to better their business.",
      link: "Read our customer stories",
    },
    home: {
      header: {
        title: "They use projetsolaire.com every day",
        overview: "Testimonials from our clients",
        all: "All testimonials and use cases from our clients",
      },
      overview: {
        hero: {
          title: "Testimonials of our simple and powerful IT solution",
          paragraph:
            "L'objectif de notre plateforme est de permettre aux installateurs photovoltaïques à forte croissance d'exploiter les technologies numériques de pointe de manière simple et collaborative. Notre solution informatique est co-développée avec nos clients pour qu'ils puissent gagner du temps pour faire plus. Nous opérons sur l'ensemble du territoire national et propulsons des milliers de projets solaires chaque année pour des entreprises de toutes tailles, des artisans de proximité aux leaders du solaire.",
        },

        testimonials: {
          heading: "Testimonials",
          title: "We have worked with hundreds of amazing installers",
          body: "Stay up to date with the latest articles from our independent editorial team.",
        },
        video: {
          testimonials: {
            title: "Écoutez nos clients",
            body: "Restez à jour avec les derniers articles de notre équipe éditoriale indépendante.",
          },
        },

        cta: {
          title: "Envie d’essayer ?",
        },
      },
      all: {
        title: "Testimonials of our simple and powerful IT solution",
        description:
          "Discover some of our hundreds of professional clients who benefit from projetsolaire.com daily. Why not you?",
      },
    },
    entry: {
      breadcrumb: {
        installer: "Installers",
        "case-studies": "Case studies",
      },
      "case-study": "Case study",
      "learn-more":
        "Learn more about how we can help your installation business",
    },
  },
  "use-cases": {
    heading: {
      "find-new-client": "Find New Clients",
      "solar-sizing": "Solar Sizing",
      "sales-and-marketing": "Sales and Marketing",
      "quotes-and-billing": "Quotes and Billing",
      "stocks-and-equipment": "Stocks and Equipment",
      "administrative-procedures": "Administrative Procedures",
      "file-tracking": "File Tracking",
      "purchase-contracts-and-business-models":
        "Purchase Contracts and Business Models",
      financing: "Financing",
      "work-and-construction": "Work and Construction",
      "web-and-mobile-software-for-project-management":
        "Web and Mobile Software for Project Management",
      "post-installation-services": "Post-Installation Services",
      "new-prospects-and-marketing": "New Prospects and Marketing",
      "customer-service": "Customer Service",
      premium: "Premium",
    },
    action: {
      "price-based-on-your-€-wc": "Price based on your €/Wc",
      "no-subscription-required": "No subscription required",
      "no-subscription": "No subscription",
      free: "Free",
      "usage-based-pricing": "Usage-based pricing",
    },
    "request-demo": "Request a demo",
    "start-now": "Start now",
    testimonials: {
      header: "Customer Testimonials",
      title: "Who better than our customers to talk about projetsolaire.com",
      type: {
        sales: "Sales Solutions",
        operations: "Operational Solutions",
      },
    },
    cta: {
      title: "Outperform the competition",
      description:
        "Discover why smart teams are already using projetsolaire.com",
    },
    "project-contact": {
      title: "All your projects. A single specialized contact.",
      description:
        "Since 2020, our design office has built up in-depth expertise and recognized know-how. Speed ​​up your construction sites and files with our automations and your all-in-one construction site management platform.",
      "link-text": "Request a demo",
      button: "Send",
      services: {
        service1: {
          title: "All powers in KW and MW",
          description:
            "Our team of specialists accompanies you for particular, tertiary, BT and HTA projects.",
        },
        service2: {
          title: "All types of PV construction sites",
          description:
            "Solar projects on roofs, new builds, shade structures, ‘small ground’? We can help you.",
        },
        service3: {
          title: "Everywhere in France",
          description:
            "In DROM-COM? We are present in Metropolitan France and Overseas.",
        },
      },
    },
    SMALL: {
      hero: {
        "icon-label": "Case Studies",
        "discover-solutions": "Discover Solutions",
        "book-demo": "Book a Demo",
        "name-orange": "Solar artisan",
        "name-black": "looking to save time",
        description:
          "Are you a local photovoltaic installer? Discover how professionals use projetsolaire daily to make money.",
      },
      works: {
        heading: "How it works",
        title: "Digital study office serving the photovoltaic craft industry.",
        steps: {
          step1: {
            title: "Account creation",
            heading:
              "No commitment. Quick and free online registration. Then, complete the account with decennial insurance, RGE, and other documents.",
          },
          step2: {
            title: "Add the first project",
            heading:
              "Enter a client and a project in just a few clicks. Manage dates and travel, then the material list and quotes using the tool.",
          },
          step3: {
            title: "Add services a la carte",
            heading:
              "Need to do the layout? A full study with a quote? Or the municipal agreement? Use only what you need.",
          },
        },
        "product-listing": {
          "networking-title": "Networking",
          "networking-desc":
            "Discover potential clients directly from your account, without paying commissions to commercial intermediaries.",
          "project-management-assistance-title":
            "Project Management Assistance",
          "project-management-assistance-desc":
            "The project manager sets the price and materials. Benefit from the technical visit and electronic signature tools to accelerate your sales.",
          "3d-sizing-tool-title": "3D Sizing Tool",
          "3d-sizing-tool-desc":
            "We have integrated Aurora Solar to provide you with the most powerful and technically accurate photovoltaic solution.",
          "shading-masks-title": "Shading Masks Compliant with RGE Audit",
          "shading-masks-desc":
            "Opt for the precision of 0.10m LIDAR in 3D to perform sunlight assessments in kWh/m² throughout France.",
          "enedis-api-title": "Enedis API and Linky Meter Data",
          "enedis-api-desc":
            "We have integrated Aurora Solar to offer you the most powerful and technically accurate photovoltaic production solution.",
          "self-consumption-title": "Self-consumption or Full-sale Studies",
          "self-consumption-desc":
            "Offer extraordinary and complete studies, with an unlimited number of techno-financial proposals per study.",
          "virtual-battery-title": "Virtual Battery Comparison Studies",
          "virtual-battery-desc":
            "Compare the profitability of the EDF OA contract with virtual battery providers MyLight150, Urban Solar Energy, JPME.",
          "physical-battery-title": "Physical Battery Studies",
          "physical-battery-desc":
            "Add a physical battery model and technical sheet for hourly analysis of self-consumption and storage profitability.",
          "profitability-studies-title":
            "Techno-financial Profitability Studies",
          "profitability-studies-desc":
            "Define the business plan for the budget. Calculate financial forecasts over 25 years. Analyze the cash flow table for the investment over the life of the project.",
          "edf-oa-tariff-title":
            "Watch the EDF OA Purchase Tariff in Mainland France and ZNI",
          "edf-oa-tariff-desc":
            "The state premiums and purchase tariffs of our studies are updated every quarter with the new tariff decrees from the CRE.",
          "tariff-comparison-title": "Comparison of Purchase Tariffs by T-0",
          "tariff-comparison-desc":
            "Compare the profitability of photovoltaic plants with state aid across different quarters to speed up your sales.",
          "credit-simulator-title": "Credit and Financing Simulator",
          "credit-simulator-desc":
            "Analyze the investment in cash, through a loan, or through roof leasing - directly integrated into the study.",
          "support-formats-title": "All Support Formats in White Label",
          "support-formats-desc":
            "Studies in interactive mini-site, PDF, spreadsheet, or mobile format.",
          "quotes-materials-title": "Quotes with Integrated Materials",
          "quotes-materials-desc":
            "Prepare your quotes from a database with thousands of modules, inverters, enclosures, batteries.",
          "accounting-numbering-title": "Accounting Numbering of Quotes",
          "accounting-numbering-desc":
            "Also customize your colors, your general terms and conditions, technical sheets, VAT certificate, and much more for your quotes.",
          "electronic-signature-title":
            "Legally Compliant Electronic Signatures",
          "electronic-signature-desc":
            "Write and have your quotes signed online, with your references and mentions. Access your quotes and documents in your account.",
          "invoices-deposits-title":
            "Accounting Invoices for Deposits and Balances",
          "invoices-deposits-desc":
            "Define your deposits, manage your transactions, add your invoices, and much more.",
          "secure-payments-title":
            "Secure Payments by Bank Transfer or Credit Card",
          "secure-payments-desc":
            "Receive your payments via simple payment pages, with several payment methods, integrated into your quotes and invoices.",
          "product-references-title":
            "10,000+ Product References: Modules, Inverters, Cabinets, Batteries ...",
          "product-references-desc":
            "Choose the product model from our real-time updated database. Save your kits and equipment lists for reduced quote and procedure input.",
          "material-lists-title": "Project Material Lists",
          "material-lists-desc":
            "Automatic planning of product and equipment lists for photovoltaic installations.",
          "technical-documents-title":
            "Technical Datasheets, Compliance Certificates, and Carbon Footprint Report",
          "technical-documents-desc":
            "Our database contains thousands of up-to-date documents for your procedures.",
          "technical-docs-title": "Professional Technical Documentation",
          "technical-docs-desc":
            "Automatically generate wiring diagrams, strapping certificates, and execution plans.",
          "material-ordering-title": "Material Ordering",
          "material-ordering-desc":
            "Request quotes from manufacturers and distributors to find competitive prices online.",
          "urban-planning-title": "Urban Planning Authorization Requests",
          "urban-planning-desc":
            "Filing the Preliminary Declaration or Building Permit for your photovoltaic installation with the relevant local authorities for approval at the town hall.",
          "gracious-appeal-title": "Gracious Appeal and DAACT",
          "gracious-appeal-desc":
            "Filing the DAACT for your photovoltaic installation with the relevant local authorities. In case of refusal, filing the gracious appeal.",
          "architect-communication-title": "Communication with Architects",
          "architect-communication-desc":
            "Conducting PLU/RNU feasibility studies, preparing graphic documents, architect certification, and submission at the town hall as required by architect regulations.",
          "connection-requests-title": "Connection Requests",
          "connection-requests-desc":
            "Obtaining the CAE contract and commissioning your photovoltaic installation with the electrical network operator Enedis or local ELD operator.",
          "collective-connection-title":
            "Collective Self-Consumption Connection Requests",
          "collective-connection-desc":
            "Our specialized partner is directly integrated into your account for community creation and PMO. Conducting CAE requests and distribution keys.",
          "consuel-certificate-title": "Consuel Certificate Visa Requests",
          "consuel-certificate-desc":
            "Filing the SC144-A, SC144-B, or SC144-C, preparing the one-line electrical diagram, then submitting the Blue or Violet Conformity Certificate (for batteries).",
          "control-office-title": "Control Office and Consuel Visa",
          "control-office-desc":
            "Technical communication with accredited organizations and obtaining the DRE conformity report. Preparing the SC144, one-line electrical diagram, and submitting the Blue or Violet AC.",
          "large-scale-sending-title":
            "Sending Within 48 Hours on a Large Scale",
          "large-scale-sending-desc":
            "Our pioneering automation and robots generate documents and fill out online forms.",
          "real-time-tracking-title": "Real-time Dated Tracking",
          "real-time-tracking-desc":
            "Your secretariat can quickly initiate and then track the progress of procedures on the same software.",
          "additional-docs-title":
            "Processing Requests for Additional Documents",
          "additional-docs-desc":
            "Our study office processes requests for additional documents to unblock the files.",
          "follow-ups-title": "Follow-ups with Administrative Bodies",
          "follow-ups-desc":
            "Our project managers follow up with administrative bodies to reduce processing times.",
          "edf-obligation-title": "EDF Purchase Obligation",
          "edf-obligation-desc":
            "Carrying out the procedure with EDF OA, automatic Affidavit or the S21 'ENR' Certificate with Carbon Footprint (for systems over 100 kWc).",
          "virtual-battery-procedure-title": "Virtual Battery Approach",
          "virtual-battery-procedure-desc":
            "Carrying out the procedure with one of the three virtual battery providers - MyLight150, Urban Solar Energy, JPME - for virtual storage.",
          "financing-report-title": "Financing Profitability Report",
          "financing-report-desc":
            "Analyze the financing of the photovoltaic investment based on energy yield, from an hourly kWh calculation.",
          "payment-savings-title":
            "Monthly Payment and Savings Effort Calculation",
          "payment-savings-desc":
            "Compare the financing of the photovoltaic investment, whether in cash or through a bank loan, integrating your OPEX and EBITDA.",
          "solar-subscription-title": "Solar Subscription",
          "solar-subscription-desc":
            "Our partner specializing in subscriptions is directly integrated into your account. Make solar subscription financing requests from the study stage.",
          "mobile-assistance-title": "Mobile Assistance for Technical Visits",
          "mobile-assistance-desc":
            "Your technical sales representatives can easily fill in client forms and upload photos and information while on the move.",
          "material-planning-title": "Material Planning",
          "material-planning-desc":
            "Automatic inventory lists of equipment available per site and per flow, for controlling material and orders.",
          "integrated-calendar-title": "Integrated Calendar",
          "integrated-calendar-desc":
            "Each team member has access, from their own account, to the company calendar for planning travels and installations. Add Google Calendar or Microsoft Outlook.",
          "client-relations-title": "Client Relations and CRM",
          "client-relations-desc":
            "Client assignments, comment space on client forms, file storage. Customizable automatic email notifications.",
          "team-access-title": "Team Access and Roles",
          "team-access-desc":
            "Sales, secretarial, and technical teams can each customize their interface. Managers have access to payments. Accounting has email access to invoices.",
          "integration-business-referrers-title":
            "Integration with Business Referrers",
          "integration-business-referrers-desc":
            "Business referrers only have access to their clients. Information visibility is customizable.",
          "custom-dashboard-title": "Customizable Dashboard",
          "custom-dashboard-desc":
            "Each team member can adjust their dashboard. Manage your sizing, studies, administrative procedures, and construction in one place.",
          "sales-cycle-tracking-title": "Sales Cycle Tracking and Reports",
          "sales-cycle-tracking-desc":
            "View key sales figures and activity in real-time. Our platform generates statistics of your projects. Receive automatic reports by email.",
          "data-export-title": "Data Export",
          "data-export-desc":
            "Need to analyze data in Excel? Need to secure the data? Export all tables and files in CSV format.",
          "as-built-files-title": "Automatic As-Built Files (DOE)",
          "as-built-files-desc":
            "Generate DOE reports in PDF or web format, shareable with clients and third parties for work acceptance reports and insurance audits.",
          "maintenance-contracts-title": "Maintenance Contracts",
          "maintenance-contracts-desc":
            "Help your clients schedule and pay for after-sales services (SAV) and maintenance contracts through online payment pages.",
          "white-label-title": "100% White Label",
          "white-label-desc":
            "Add your logo and main colors, buttons, and graphics. Customize the interfaces. Enhance your brand.",
          "white-label-client-portal-title": "White Label Client Portal",
          "white-label-client-portal-desc":
            "Invite your clients to an online space to view your study, sign your quote, and track the progress of their case. Your clients can enter information and documents.",
          "login-registration-pages-title":
            "Login and Registration Pages on Website",
          "login-registration-pages-desc":
            "Invite your clients to log into their white label client portal from your website.",
          "seo-title": "Search Engine Optimization and SEO",
          "seo-desc":
            "Fill in the customizable profile 'Our establishment' available on studies and in our directory.",
          "online-messaging-title": "Online Messaging",
          "online-messaging-desc":
            "Our team responds within minutes with written records.",
          "phone-support-title": "Phone Support",
          "phone-support-desc":
            "Our team is always available to assist you with your procedures.",
          "email-title": "Email",
          "email-desc":
            "Our team is available by email to facilitate your communications with third parties.",
          "video-conference-appointments-title":
            "Video Conference Appointments",
          "video-conference-appointments-desc":
            "Our team is here to listen and help you develop your follow-up together.",
          "file-transfer-title": "File Transfer",
          "file-transfer-desc":
            "Our IT teams assist you in migrating data and files to our system so you can manage operations.",
        },
      },
    },
    REGIONAL: {
      hero: {
        "icon-label": "Case Studies",
        "discover-solutions": "Discover Solutions",
        "book-demo": "Book a Demo",
        "name-orange": "Local SME",
        "name-black": "enhancing its brand image",
        description:
          "Are you a photovoltaic installer operating in multiple regions? Discover how professionals use projetsolaire to simplify their daily operations.",
      },
      works: {
        heading: "How it works",
        title: "Digital study office designed for photovoltaic teams.",

        steps: {
          step1: {
            title: "Account creation",
            heading:
              "No commitment. Quick and free online registration. Then, complete the account with decennial insurance, RGE, and other documents.",
          },
          step2: {
            title: "Invite the team",
            heading:
              "Enter your teammates in just a few clicks. Manage roles and access for your teams. Oversee clients, projects, and travel.",
          },
          step3: {
            title: "Starting training",
            heading:
              "Your teams are trained by our team on the IT solutions. Our teams will assist you with IT integrations.",
          },
        },
      },
      "product-listing": {
        "networking-title": "Networking",
        "networking-desc":
          "Discover potential clients directly from your account, without paying commissions to business introducers.",
        "project-management-assistance-title": "Project Management Assistance",
        "project-management-assistance-desc":
          "The project manager sets the price and materials. Benefit from the technical visit and electronic signature tools to accelerate your sales.",
        "3d-sizing-tool-title": "3D Sizing Tool",
        "3d-sizing-tool-desc":
          "We have integrated Aurora Solar to provide you with the most powerful and technically accurate photovoltaic yield solution.",
        "shading-masks-title": "Shading Masks Compliant with RGE Audit",
        "shading-masks-desc":
          "Opt for the precision of 0.10m LIDAR in 3D to perform sunlight assessments in kWh/m² throughout France.",
        "enedis-api-title": "Enedis API and Linky Meter Data",
        "enedis-api-desc":
          "We have integrated Aurora Solar to offer you the most powerful and technically accurate photovoltaic production solution.",
        "self-consumption-studies-title":
          "Self-consumption or full-sale studies",
        "self-consumption-studies-desc":
          "Offer extraordinary and complete studies, with an unlimited number of techno-financial proposals per study.",
        "virtual-battery-comparison-title":
          "Virtual Battery Comparison Studies",
        "virtual-battery-comparison-desc":
          "Compare the profitability of the EDF OA contract with virtual battery providers MyLight150, Urban Solar Energy, JPME.",
        "physical-battery-studies-title": "Physical Battery Studies",
        "physical-battery-studies-desc":
          "Add a physical battery model and technical sheet for hourly analysis of self-consumption and storage profitability.",
        "techno-financial-profitability-studies-title":
          "Techno-financial Profitability Studies",
        "techno-financial-profitability-studies-desc":
          "Define the business plan for the budget. Calculate financial forecasts over 25 years. Analyze the cash flow table for the investment over the life of the project.",
        "edf-oa-purchase-tariff-title":
          "Watch the EDF OA purchase tariff in mainland France and ZNI",
        "edf-oa-purchase-tariff-desc":
          "The state premiums and purchase tariffs of our studies are updated every quarter with the new tariff decrees from the CRE.",
        "purchase-tariff-comparison-title":
          "Comparison of purchase tariffs by T-0",
        "purchase-tariff-comparison-desc":
          "Compare the profitability of photovoltaic plants with state aid across different quarters to speed up your sales.",
        "credit-financing-simulator-title": "Credit and Financing Simulator",
        "credit-financing-simulator-desc":
          "Analyze the investment in cash, through a loan, or through roof leasing - directly integrated into the study.",
        "enedis-costs-simulator-title": "Enedis Costs Simulator",
        "enedis-costs-simulator-desc":
          "Estimate the costs of reinforcing the electrical network based on Enedis' billing scale. The only alternative to the PTF in France.",
        "white-label-support-formats-title":
          "All support formats in white label",
        "white-label-support-formats-desc":
          "Studies in interactive mini-site, PDF, spreadsheet, or mobile format.",
        "quotes-with-integrated-materials-title":
          "Quotes with integrated materials",
        "quotes-with-integrated-materials-desc":
          "Prepare your quotes from a database with thousands of modules, inverters, enclosures, batteries.",
        "accounting-numbering-of-quotes-title":
          "Accounting numbering of quotes",
        "accounting-numbering-of-quotes-desc":
          "Also customize your colors, your general terms and conditions, technical sheets, VAT certificate, and much more for your quotes.",
        "legally-compliant-electronic-signatures-title":
          "Legally compliant electronic signatures",
        "legally-compliant-electronic-signatures-desc":
          "Write and have your quotes signed online, with your references and mentions. Access your quotes and documents in your account.",
        "accounting-invoices-for-deposits-and-balances-title":
          "Accounting invoices for deposits and balances",
        "accounting-invoices-for-deposits-and-balances-desc":
          "Define your deposits, manage your transactions, add your invoices, and much more.",
        "secure-payments-by-bank-transfer-or-credit-card-title":
          "Secure payments by bank transfer or credit card",
        "secure-payments-by-bank-transfer-or-credit-card-desc":
          "Receive your payments via simple payment pages, with several payment methods, integrated into your quotes and invoices.",
        "10000-plus-product-references-title":
          "10,000+ product references: modules, inverters, cabinets, batteries ...",
        "10000-plus-product-references-desc":
          "Choose the product model from our real-time updated database. Save your kits and equipment lists for reduced quote and procedure input.",
        "project-material-lists-title": "Project material lists",
        "project-material-lists-desc":
          "Automatic planning of product and equipment lists for photovoltaic installations.",
        "technical-datasheets-compliance-certificates-and-carbon-footprint-report-title":
          "Technical datasheets, Compliance Certificates, and Carbon Footprint Report",
        "technical-datasheets-compliance-certificates-and-carbon-footprint-report-desc":
          "Our database contains thousands of up-to-date documents for your procedures.",
        "professional-technical-documentation-title":
          "Professional technical documentation",
        "professional-technical-documentation-desc":
          "Automatically generate wiring diagrams, Strapping certificates, and Execution plans.",
        "material-ordering-title": "Material ordering",
        "material-ordering-desc":
          "Request quotes from manufacturers and distributors to find competitive prices online.",
        "urban-planning-authorization-requests-title":
          "Urban Planning Authorization Requests",
        "urban-planning-authorization-requests-desc":
          "Filing the Preliminary Declaration or Building Permit for your photovoltaic installation with the relevant local authorities for approval at the town hall.",
        "gracious-appeal-and-daact-title": "Gracious Appeal and DAACT",
        "gracious-appeal-and-daact-desc":
          "Filing the DAACT for your photovoltaic installation with the relevant local authorities. In case of refusal, filing the gracious appeal.",
        "communication-with-architects-title": "Communication with Architects",
        "communication-with-architects-desc":
          "Conducting PLU/RNU feasibility studies, preparing graphic documents, architect certification, and submission at the town hall as required by architect regulations.",
        "connection-requests-title": "Connection Requests",
        "connection-requests-desc":
          "Obtaining the CAE contract and commissioning your photovoltaic installation with the electrical network operator Enedis or local ELD operator.",
        "low-or-medium-voltage-connection-requests-title":
          "Low or Medium Voltage Connection Requests",
        "low-or-medium-voltage-connection-requests-desc":
          "Obtaining the PTF and CACS-i contract, then commissioning your photovoltaic installation with the electrical network operator Enedis or local ELD operator.",
        "collective-self-consumption-connection-requests-title":
          "Collective Self-Consumption Connection Requests",
        "collective-self-consumption-connection-requests-desc":
          "Our specialized partner is directly integrated into your account for community creation and PMO. Conducting CAE requests and distribution keys.",
        "consuel-certificate-visa-requests-title":
          "Consuel Certificate Visa Requests",
        "consuel-certificate-visa-requests-desc":
          "Filing the SC144-A, SC144-B, or SC144-C, preparing the one-line electrical diagram, then submitting the Blue or Violet Conformity Certificate (for batteries).",
        "control-office-and-consuel-visa-title":
          "Control Office and Consuel Visa",
        "control-office-and-consuel-visa-desc":
          "Technical communication with accredited organizations and obtaining the DRE conformity report. Preparing the SC144, one-line electrical diagram, and submitting the Blue or Violet AC.",
        "large-scale-sending-title": "Sending Within 48 Hours on a Large Scale",
        "large-scale-sending-desc":
          "Our pioneering automation and robots generate documents and fill out online forms.",
        "real-time-tracking-title": "Real-time Dated Tracking",
        "real-time-tracking-desc":
          "Your secretariat can quickly initiate and then track the progress of procedures on the same software.",
        "additional-docs-title": "Processing Requests for Additional Documents",
        "additional-docs-desc":
          "Our study office processes requests for additional documents to unblock the files.",
        "follow-ups-title": "Follow-ups with Administrative Bodies",
        "follow-ups-desc":
          "Our project managers follow up with administrative bodies to reduce processing times.",
        "edf-obligation-title": "EDF Purchase Obligation",
        "edf-obligation-desc":
          "Carrying out the procedure with EDF OA, automatic Affidavit or the S21 'ENR' Certificate with Carbon Footprint (for systems over 100 kWc).",
        "virtual-battery-procedure-title": "Virtual Battery Approach",
        "virtual-battery-procedure-desc":
          "Carrying out the procedure with one of the three virtual battery providers - MyLight150, Urban Solar Energy, JPME - for virtual storage.",
        "financing-report-title": "Financing Profitability Report",
        "financing-report-desc":
          "Analyze the financing of the photovoltaic investment based on energy yield, from an hourly kWh calculation.",
        "payment-savings-title":
          "Monthly Payment and Savings Effort Calculation",
        "payment-savings-desc":
          "Compare the financing of the photovoltaic investment, whether in cash or through a bank loan, integrating your OPEX and EBITDA.",
        "solar-subscription-title": "Solar Subscription",
        "solar-subscription-desc":
          "Our partner specializing in subscriptions is directly integrated into your account. Make solar subscription financing requests from the study stage.",
        "creation-and-management-of-spvs-title":
          "Creation and Management of SPVs",
        "creation-and-management-of-spvs-desc":
          "Your team organizes project portfolios by SPV directly from your account. Our project managers can create the SIRET numbers and assist with notaries.",
        "mobile-assistance-for-technical-visits-title":
          "Mobile Assistance for Technical Visits",
        "mobile-assistance-for-technical-visits-desc":
          "Your technical sales representatives can easily fill in client forms and upload photos and information while on the move.",
        "material-planning-title": "Material Planning",
        "material-planning-desc":
          "Automatic inventory lists of equipment available per site and per flow, for controlling material and orders.",
        "integrated-calendar-title": "Integrated Calendar",
        "integrated-calendar-desc":
          "Each team member has access, from their own account, to the company calendar for planning travels and installations. Add Google Calendar or Microsoft Outlook.",
        "subcontractor-management-for-installers-title":
          "Subcontractor Management for Installers",
        "subcontractor-management-for-installers-desc":
          "Your technical documents can be shared directly from your account with your project partners, to facilitate installation, Consuel, and Control Bureau.",
        "client-relations-title": "Client Relations and CRM",
        "client-relations-desc":
          "Client assignments, comment space on client forms, file storage. Customizable automatic email notifications.",
        "team-access-title": "Team Access and Roles",
        "team-access-desc":
          "Sales, secretarial, and technical teams can each customize their interface. Managers have access to payments. Accounting has email access to invoices.",
        "integration-business-referrers-title":
          "Integration with Business Referrers",
        "integration-business-referrers-desc":
          "Business referrers only have access to their clients. Information visibility is customizable.",
        "custom-dashboard-title": "Customizable Dashboard",
        "custom-dashboard-desc":
          "Each team member can adjust their dashboard. Manage your sizing, studies, administrative procedures, and construction in one place.",
        "sales-cycle-tracking-title": "Sales Cycle Tracking and Reports",
        "sales-cycle-tracking-desc":
          "View key sales figures and activity in real-time. Our platform generates statistics of your projects. Receive automatic reports by email.",
        "data-export-title": "Data Export",
        "data-export-desc":
          "Need to analyze data in Excel? Need to secure the data? Export all tables and files in CSV format.",
        "as-built-files-title": "Automatic As-Built Files (DOE)",
        "as-built-files-desc":
          "Generate DOE reports in PDF or web format, shareable with clients and third parties for work acceptance reports and insurance audits.",
        "maintenance-contracts-title": "Maintenance Contracts",
        "maintenance-contracts-desc":
          "Help your clients schedule and pay for after-sales services (SAV) and maintenance contracts through online payment pages.",
        "white-label-title": "100% White Label",
        "white-label-desc":
          "Add your logo and main colors, buttons, and graphics. Customize the interfaces. Enhance your brand.",
        "white-label-client-portal-title": "White Label Client Portal",
        "white-label-client-portal-desc":
          "Invite your clients to an online space to view your study, sign your quote, and track the progress of their case. Your clients can enter information and documents.",
        "login-registration-pages-title":
          "Login and Registration Pages on Website",
        "login-registration-pages-desc":
          "Invite your clients to log into their white label client portal from your website.",
        "seo-title": "Search Engine Optimization and SEO",
        "seo-desc":
          "Fill in the customizable profile 'Our establishment' available on studies and in our directory.",
        "online-messaging-title": "Online Messaging",
        "online-messaging-desc":
          "Our team responds within minutes with written records.",
        "phone-support-title": "Phone Support",
        "phone-support-desc":
          "Our team is always available to assist you with your procedures.",
        "email-title": "Email",
        "email-desc":
          "Our team is available by email to facilitate your communications with third parties.",
        "video-conference-appointments-title": "Video Conference Appointments",
        "video-conference-appointments-desc":
          "Our team is here to listen and help you develop your follow-up together.",
        "file-transfer-title": "File Transfer",
        "file-transfer-desc":
          "Our IT teams assist you in migrating data and files to our system so you can manage operations.",
      },
    },
    NATIONAL: {
      hero: {
        "icon-label": "Case Studies",
        "discover-solutions": "Discover Solutions",
        "book-demo": "Book a Demo",
        "name-orange": "National player",
        "name-black": "seeking operational excellence",
        description:
          "Are you a nationwide operator handling numerous projects across France? Discover how to reduce your cost per watt with digital solutions.",
      },
      works: {
        heading: "How it works",
        title: "Digital study office adapted for management across France.",

        steps: {
          step1: {
            title: "Account opening",
            heading:
              "No commitment. Quick and free online registration. Then, customize your colors, company presentation, and brand image.",
          },
          step2: {
            title: "File transfer",
            heading:
              "Our IT teams assist you in migrating data and files to our system so you can manage operations.",
          },
          step3: {
            title: "Starting Steering Committee",
            heading:
              "Service organization around detailed reports and bi-monthly meetings with a single point of contact and project managers.",
          },
        },
      },
      "product-listing": {
        "networking-title": "Networking",
        "networking-desc":
          "Discover potential clients directly from your account, without paying commissions to commercial intermediaries.",
        "project-management-assistance-title": "Project Management Assistance",
        "project-management-assistance-desc":
          "The project manager sets the price and materials. Benefit from the technical visit and electronic signature tools to accelerate your sales.",
        "3d-sizing-tool-title": "3D Sizing Tool",
        "3d-sizing-tool-desc":
          "We have integrated Aurora Solar to provide you with the most powerful and technically accurate photovoltaic yield solution.",
        "shading-masks-compliant-with-rge-audit-title":
          "Shading Masks Compliant with RGE Audit",
        "shading-masks-compliant-with-rge-audit-desc":
          "Opt for the precision of 0.10m LIDAR in 3D to perform sunlight assessments in kWh/m² throughout France.",
        "technical-design-with-pv-syst-title": "Technical Design with PV SYST",
        "technical-design-with-pv-syst-desc":
          "The electrical engineers from our study office carry out the design of inverters and Pnom, P50-P95 optimization for projects.",
        "enedis-api-title": "Enedis API and Linky Meter Data",
        "enedis-api-desc":
          "We have integrated Aurora Solar to offer you the most powerful and technically accurate photovoltaic production solution.",
        "self-consumption-or-full-sale-studies-title":
          "Self-consumption or full-sale studies",
        "self-consumption-or-full-sale-studies-desc":
          "Offer extraordinary and complete studies, with an unlimited number of techno-financial proposals per study.",
        "virtual-battery-comparison-studies-title":
          "Virtual Battery Comparison Studies",
        "virtual-battery-comparison-studies-desc":
          "Compare the profitability of the EDF OA contract with virtual battery providers MyLight150, Urban Solar Energy, JPME.",
        "physical-battery-studies-title": "Physical Battery Studies",
        "physical-battery-studies-desc":
          "Add a physical battery model and technical sheet for hourly analysis of self-consumption and storage profitability.",
        "techno-financial-profitability-studies-title":
          "Techno-financial Profitability Studies",
        "techno-financial-profitability-studies-desc":
          "Define the business plan for the budget. Calculate financial forecasts over 25 years. Analyze the cash flow table for the investment over the life of the project.",
        "watch-the-edf-oa-purchase-tariff-title":
          "Watch the EDF OA purchase tariff in mainland France and ZNI",
        "watch-the-edf-oa-purchase-tariff-desc":
          "The state premiums and purchase tariffs of our studies are updated every quarter with the new tariff decrees from the CRE.",
        "comparison-of-purchase-tariffs-by-t-0-title":
          "Comparison of purchase tariffs by T-0",
        "comparison-of-purchase-tariffs-by-t-0-desc":
          "Compare the profitability of photovoltaic plants with state aid across different quarters to speed up your sales.",
        "credit-and-financing-simulator-title":
          "Credit and Financing Simulator",
        "credit-and-financing-simulator-desc":
          "Analyze the investment in cash, through a loan, or through roof leasing - directly integrated into the study.",
        "enedis-costs-simulator-title": "Enedis Costs Simulator",
        "enedis-costs-simulator-desc":
          "Estimate the costs of reinforcing the electrical network based on Enedis' billing scale. The only alternative to the PTF in France.",
        "all-support-formats-in-white-label-title":
          "All support formats in white label",
        "all-support-formats-in-white-label-desc":
          "Studies in interactive mini-site, PDF, spreadsheet, or mobile format.",
        "quotes-with-integrated-materials-title":
          "Quotes with integrated materials",
        "quotes-with-integrated-materials-desc":
          "Prepare your quotes from a database with thousands of modules, inverters, enclosures, batteries.",
        "accounting-numbering-of-quotes-title":
          "Accounting numbering of quotes",
        "accounting-numbering-of-quotes-desc":
          "Also customize your colors, your general terms and conditions, technical sheets, VAT certificate, and much more for your quotes.",
        "legally-compliant-electronic-signatures-title":
          "Legally compliant electronic signatures",
        "legally-compliant-electronic-signatures-desc":
          "Write and have your quotes signed online, with your references and mentions. Access your quotes and documents in your account.",
        "accounting-invoices-for-deposits-and-balances-title":
          "Accounting invoices for deposits and balances",
        "accounting-invoices-for-deposits-and-balances-desc":
          "Define your deposits, manage your transactions, add your invoices, and much more.",
        "secure-payments-by-bank-transfer-or-credit-card-title":
          "Secure payments by bank transfer or credit card",
        "secure-payments-by-bank-transfer-or-credit-card-desc":
          "Receive your payments via simple payment pages, with several payment methods, integrated into your quotes and invoices.",
        "10000-product-references-title":
          "10,000+ product references: modules, inverters, cabinets, batteries ...",
        "10000-product-references-desc":
          "Choose the product model from our real-time updated database. Save your kits and equipment lists for reduced quote and procedure input.",
        "project-material-lists-title": "Project material lists",
        "project-material-lists-desc":
          "Automatic planning of product and equipment lists for photovoltaic installations.",
        "technical-datasheets-compliance-certificates-and-carbon-footprint-report-title":
          "Technical datasheets, Compliance Certificates, and Carbon Footprint Report",
        "technical-datasheets-compliance-certificates-and-carbon-footprint-report-desc":
          "Our database contains thousands of up-to-date documents for your procedures.",
        "professional-technical-documentation-title":
          "Professional technical documentation",
        "professional-technical-documentation-desc":
          "Automatically generate wiring diagrams, Strapping certificates, and Execution plans.",
        "material-ordering-title": "Material ordering",
        "material-ordering-desc":
          "Request quotes from manufacturers and distributors to find competitive prices online.",
        "urban-planning-authorization-requests-title":
          "Urban Planning Authorization Requests",
        "urban-planning-authorization-requests-desc":
          "Filing the Preliminary Declaration or Building Permit for your photovoltaic installation with the relevant local authorities for approval at the town hall.",
        "gracious-appeal-and-daact-title": "Gracious Appeal and DAACT",
        "gracious-appeal-and-daact-desc":
          "Filing the DAACT for your photovoltaic installation with the relevant local authorities. In case of refusal, filing the gracious appeal.",
        "communication-with-architects-title": "Communication with Architects",
        "communication-with-architects-desc":
          "Conducting PLU/RNU feasibility studies, preparing graphic documents, architect certification, and submission at the town hall as required by architect regulations.",
        "building-permit-expiry-title": "Building Permit Expiry",
        "building-permit-expiry-desc":
          "Filing the DOC, then conducting notary reports, EDDV, and DAACT for your photovoltaic installation with the relevant local authorities.",
        "preliminary-declarations-small-land-title":
          "Preliminary Declarations 'Small Land'",
        "preliminary-declarations-small-land-desc":
          "Conducting PLU/RNU feasibility studies, preparing the agricultural form, case-by-case study, and submitting the Preliminary Declaration at the town hall.",
        "connection-requests-title": "Connection Requests",
        "connection-requests-desc":
          "Obtaining the CAE contract and commissioning your photovoltaic installation with the electrical network operator Enedis or local ELD operator.",
        "low-or-medium-voltage-connection-requests-title":
          "Low or Medium Voltage Connection Requests",
        "low-or-medium-voltage-connection-requests-desc":
          "Obtaining the PTF and CACS-i contract, then commissioning your photovoltaic installation with the electrical network operator Enedis or local ELD operator.",
        "collective-self-consumption-connection-requests-title":
          "Collective Self-Consumption Connection Requests",
        "collective-self-consumption-connection-requests-desc":
          "Our specialized partner is directly integrated into your account for community creation and PMO. Conducting CAE requests and distribution keys.",
        "consuel-certificate-visa-requests-title":
          "Consuel Certificate Visa Requests",
        "consuel-certificate-visa-requests-desc":
          "Filing the SC144-A, SC144-B, or SC144-C, preparing the one-line electrical diagram, then submitting the Blue or Violet Conformity Certificate (for batteries).",
        "control-office-and-consuel-visa-title":
          "Control Office and Consuel Visa",
        "control-office-and-consuel-visa-desc":
          "Technical communication with accredited organizations and obtaining the DRE conformity report. Preparing the SC144, one-line electrical diagram, and submitting the Blue or Violet AC.",
        "sending-within-48-hours-on-a-large-scale-title":
          "Sending within 48 hours on a large scale",
        "sending-within-48-hours-on-a-large-scale-desc":
          "Our pioneering automation and robots generate documents and fill out online forms.",
        "real-time-dated-tracking-title": "Real-time dated tracking",
        "real-time-dated-tracking-desc":
          "Your secretariat can quickly initiate and then track the progress of procedures on the same software.",
        "processing-requests-for-additional-documents-title":
          "Processing requests for additional documents",
        "processing-requests-for-additional-documents-desc":
          "Our study office processes requests for additional documents to unblock the files.",
        "follow-ups-with-administrative-bodies-title":
          "Follow-ups with administrative bodies",
        "follow-ups-with-administrative-bodies-desc":
          "Our project managers follow up with administrative bodies to reduce processing times.",
        "edf-purchase-obligation-title": "EDF Purchase Obligation",
        "edf-purchase-obligation-desc":
          "Carrying out the procedure with EDF OA, automatic Affidavit or the S21 'ENR' Certificate with Carbon Footprint (for systems over 100 kWc).",
        "arpe-procedure-title": "ARPE Procedure",
        "arpe-procedure-desc":
          "Carrying out the procedure with an alternative buyer - Octopus Energie, Ekwateur, etc. - for PPE contracts and other purchase agreements.",
        "virtual-battery-procedure-title": "Virtual Battery Approach",
        "virtual-battery-procedure-desc":
          "Carrying out the procedure with one of the three virtual battery providers - MyLight150, Urban Solar Energy, JPME - for virtual storage.",
        "financing-profitability-report-title":
          "Financing Profitability Report",
        "financing-profitability-report-desc":
          "Analyze the financing of the photovoltaic investment based on energy yield, from an hourly kWh calculation.",
        "monthly-payment-savings-effort-calculation-title":
          "Monthly Payment and Savings Effort Calculation",
        "monthly-payment-savings-effort-calculation-desc":
          "Compare the financing of the photovoltaic investment, whether in cash or through a bank loan, integrating your OPEX and EBITDA.",
        "solar-subscription-title": "Solar Subscription",
        "solar-subscription-desc":
          "Our partner specializing in subscriptions is directly integrated into your account. Make solar subscription financing requests from the study stage.",
        "creation-management-spvs-title": "Creation and Management of SPVs",
        "creation-management-spvs-desc":
          "Your team organizes project portfolios by SPV directly from your account. Our project managers can create the SIRET numbers and assist with notaries.",
        "mobile-assistance-for-technical-visits-title":
          "Mobile Assistance for Technical Visits",
        "mobile-assistance-for-technical-visits-desc":
          "Your technical sales representatives can easily fill in client forms and upload photos and information while on the move.",
        "material-planning-title": "Material Planning",
        "material-planning-desc":
          "Automatic inventory lists of equipment available per site and per flow, for controlling material and orders.",
        "integrated-calendar-title": "Integrated Calendar",
        "integrated-calendar-desc":
          "Each team member has access, from their own account, to the company calendar for planning travels and installations. Add Google Calendar or Microsoft Outlook.",
        "subcontractor-management-for-installers-title":
          "Subcontractor Management for Installers",
        "subcontractor-management-for-installers-desc":
          "Your technical documents can be shared directly from your account with your project partners, to facilitate installation, Consuel, and Control Bureau.",
        "client-relations-and-crm-title": "Client Relations and CRM",
        "client-relations-and-crm-desc":
          "Client assignments, comment space on client forms, file storage. Customizable automatic email notifications.",
        "team-access-and-roles-title": "Team Access and Roles",
        "team-access-and-roles-desc":
          "Sales, secretarial, and technical teams can each customize their interface. Managers have access to payments. Accounting has email access to invoices.",
        "integration-with-business-referrers-title":
          "Integration with Business Referrers",
        "integration-with-business-referrers-desc":
          "Business referrers only have access to their clients. Information visibility is customizable.",
        "customizable-dashboard-title": "Customizable Dashboard",
        "customizable-dashboard-desc":
          "Each team member can adjust their dashboard. Manage your sizing, studies, administrative procedures, and construction in one place.",
        "sales-cycle-tracking-and-reports-title":
          "Sales Cycle Tracking and Reports",
        "sales-cycle-tracking-and-reports-desc":
          "View key sales figures and activity in real-time. Our platform generates statistics of your projects. Receive automatic reports by email.",
        "data-export-title": "Data Export",
        "data-export-desc":
          "Need to analyze data in Excel? Need to secure the data? Export all tables and files in CSV format.",
        "automatic-as-built-files-title": "Automatic As-Built Files (DOE)",
        "automatic-as-built-files-desc":
          "Generate DOE reports in PDF or web format, shareable with clients and third parties for work acceptance reports and insurance audits.",
        "maintenance-contracts-title": "Maintenance Contracts",
        "maintenance-contracts-desc":
          "Help your clients schedule and pay for after-sales services (SAV) and maintenance contracts through online payment pages.",
        "white-label-100-title": "100% White Label",
        "white-label-100-desc":
          "Add your logo and main colors, buttons, and graphics. Customize the interfaces. Enhance your brand.",
        "white-label-client-portal-title": "White Label Client Portal",
        "white-label-client-portal-desc":
          "Invite your clients to an online space to view your study, sign your quote, and track the progress of their case. Your clients can enter information and documents.",
        "login-and-registration-pages-title":
          "Login and Registration Pages on Website",
        "login-and-registration-pages-desc":
          "Invite your clients to log into their white label client portal from your website.",
        "seo-title": "Search Engine Optimization and SEO",
        "seo-desc":
          "Fill in the customizable profile 'Our establishment' available on studies and in our directory.",
        "online-messaging-title": "Online Messaging",
        "online-messaging-desc":
          "Our team responds within minutes with written records.",
        "phone-support-title": "Phone Support",
        "phone-support-desc":
          "Our team is always available to assist you with your procedures.",
        "email-title": "Email",
        "email-desc":
          "Our team is available by email to facilitate your communications with third parties.",
        "video-conference-appointments-title": "Video Conference Appointments",
        "video-conference-appointments-desc":
          "Our team is here to listen and help you develop your follow-up together.",
        "file-transfer-title": "File Transfer",
        "file-transfer-desc":
          "Our IT teams assist you in migrating data and files to our system so you can manage operations.",
        "bi-monthly-steering-committee-title": "Bi-monthly Steering Committee",
        "bi-monthly-steering-committee-desc":
          "Service organization around detailed reports and meetings every 15 days with a single point of contact and project managers.",
        "exclusive-access-title": "Exclusive Access",
        "exclusive-access-desc": "Your key teams are invited to join.",
      },
    },
    COMMERCIAL_REGIE: {
      hero: {
        "icon-label": "Use cases",
        "discover-solutions": "Discover solutions",
        "book-demo": "Request your demo",
        "name-orange": "Commercial agency",
        "name-black": "looking for subcontracting",
        description:
          "Are you a client looking for installation subcontractors? Discover the network of thousands of installers on projetsolaire.",
      },
      works: {
        heading: "How it works",
        title:
          "A platform for connecting with the solar and storage industry",

        steps: {
          step1: {
            title: "Open your account",
            heading:
              "No commitment. Fast, free online registration. Then complete your account with your payment information, insurance, and other documents.",
          },
          step2: {
            title: "Publish your projects",
            heading:
              "Select the equipment you sell from our database. Enter your prices, terms, and stock availability.",
          },
          step3: {
            title: "Secure operations",
            heading:
              "Need accurate layout drawings? Profitability studies? Or municipal approvals? Use only what you need.",
          },
        },
      },
      "product-listing": {
        "networking-title": "Networking",
        "networking-desc":
          "Discover potential clients directly from your account, without paying commissions to business introducers.",
        "project-management-assistance-title": "Project Management Assistance",
        "project-management-assistance-desc":
          "The project manager sets the price and materials. Benefit from the technical visit and electronic signature tools to accelerate your sales.",
        "3d-sizing-tool-title": "3D Sizing Tool",
        "3d-sizing-tool-desc":
          "We have integrated Aurora Solar to provide you with the most powerful and technically accurate photovoltaic yield solution.",
        "shading-masks-title": "Shading Masks Compliant with RGE Audit",
        "shading-masks-desc":
          "Opt for the precision of 0.10m LIDAR in 3D to perform sunlight assessments in kWh/m² throughout France.",
        "enedis-api-title": "Enedis API and Linky Meter Data",
        "enedis-api-desc":
          "We have integrated Aurora Solar to offer you the most powerful and technically accurate photovoltaic production solution.",
        "self-consumption-studies-title":
          "Self-consumption or full-sale studies",
        "self-consumption-studies-desc":
          "Offer extraordinary and complete studies, with an unlimited number of techno-financial proposals per study.",
        "virtual-battery-comparison-title":
          "Virtual Battery Comparison Studies",
        "virtual-battery-comparison-desc":
          "Compare the profitability of the EDF OA contract with virtual battery providers MyLight150, Urban Solar Energy, JPME.",
        "physical-battery-studies-title": "Physical Battery Studies",
        "physical-battery-studies-desc":
          "Add a physical battery model and technical sheet for hourly analysis of self-consumption and storage profitability.",
        "techno-financial-profitability-studies-title":
          "Techno-financial Profitability Studies",
        "techno-financial-profitability-studies-desc":
          "Define the business plan for the budget. Calculate financial forecasts over 25 years. Analyze the cash flow table for the investment over the life of the project.",
        "edf-oa-purchase-tariff-title":
          "Watch the EDF OA purchase tariff in mainland France and ZNI",
        "edf-oa-purchase-tariff-desc":
          "The state premiums and purchase tariffs of our studies are updated every quarter with the new tariff decrees from the CRE.",
        "purchase-tariff-comparison-title":
          "Comparison of purchase tariffs by T-0",
        "purchase-tariff-comparison-desc":
          "Compare the profitability of photovoltaic plants with state aid across different quarters to speed up your sales.",
        "credit-financing-simulator-title": "Credit and Financing Simulator",
        "credit-financing-simulator-desc":
          "Analyze the investment in cash, through a loan, or through roof leasing - directly integrated into the study.",
        "enedis-costs-simulator-title": "Enedis Costs Simulator",
        "enedis-costs-simulator-desc":
          "Estimate the costs of reinforcing the electrical network based on Enedis' billing scale. The only alternative to the PTF in France.",
        "white-label-support-formats-title":
          "All support formats in white label",
        "white-label-support-formats-desc":
          "Studies in interactive mini-site, PDF, spreadsheet, or mobile format.",
        "quotes-with-integrated-materials-title":
          "Quotes with integrated materials",
        "quotes-with-integrated-materials-desc":
          "Prepare your quotes from a database with thousands of modules, inverters, enclosures, batteries.",
        "accounting-numbering-of-quotes-title":
          "Accounting numbering of quotes",
        "accounting-numbering-of-quotes-desc":
          "Also customize your colors, your general terms and conditions, technical sheets, VAT certificate, and much more for your quotes.",
        "legally-compliant-electronic-signatures-title":
          "Legally compliant electronic signatures",
        "legally-compliant-electronic-signatures-desc":
          "Write and have your quotes signed online, with your references and mentions. Access your quotes and documents in your account.",
        "accounting-invoices-for-deposits-and-balances-title":
          "Accounting invoices for deposits and balances",
        "accounting-invoices-for-deposits-and-balances-desc":
          "Define your deposits, manage your transactions, add your invoices, and much more.",
        "secure-payments-by-bank-transfer-or-credit-card-title":
          "Secure payments by bank transfer or credit card",
        "secure-payments-by-bank-transfer-or-credit-card-desc":
          "Receive your payments via simple payment pages, with several payment methods, integrated into your quotes and invoices.",
        "10000-plus-product-references-title":
          "10,000+ product references: modules, inverters, cabinets, batteries ...",
        "10000-plus-product-references-desc":
          "Choose the product model from our real-time updated database. Save your kits and equipment lists for reduced quote and procedure input.",
        "project-material-lists-title": "Project material lists",
        "project-material-lists-desc":
          "Automatic planning of product and equipment lists for photovoltaic installations.",
        "technical-datasheets-compliance-certificates-and-carbon-footprint-report-title":
          "Technical datasheets, Compliance Certificates, and Carbon Footprint Report",
        "technical-datasheets-compliance-certificates-and-carbon-footprint-report-desc":
          "Our database contains thousands of up-to-date documents for your procedures.",
        "professional-technical-documentation-title":
          "Professional technical documentation",
        "professional-technical-documentation-desc":
          "Automatically generate wiring diagrams, Strapping certificates, and Execution plans.",
        "material-ordering-title": "Material ordering",
        "material-ordering-desc":
          "Request quotes from manufacturers and distributors to find competitive prices online.",
        "urban-planning-authorization-requests-title":
          "Urban Planning Authorization Requests",
        "urban-planning-authorization-requests-desc":
          "Filing the Preliminary Declaration or Building Permit for your photovoltaic installation with the relevant local authorities for approval at the town hall.",
        "gracious-appeal-and-daact-title": "Gracious Appeal and DAACT",
        "gracious-appeal-and-daact-desc":
          "Filing the DAACT for your photovoltaic installation with the relevant local authorities. In case of refusal, filing the gracious appeal.",
        "communication-with-architects-title": "Communication with Architects",
        "communication-with-architects-desc":
          "Conducting PLU/RNU feasibility studies, preparing graphic documents, architect certification, and submission at the town hall as required by architect regulations.",
        "connection-requests-title": "Connection Requests",
        "connection-requests-desc":
          "Obtaining the CAE contract and commissioning your photovoltaic installation with the electrical network operator Enedis or local ELD operator.",
        "low-or-medium-voltage-connection-requests-title":
          "Low or Medium Voltage Connection Requests",
        "low-or-medium-voltage-connection-requests-desc":
          "Obtaining the PTF and CACS-i contract, then commissioning your photovoltaic installation with the electrical network operator Enedis or local ELD operator.",
        "collective-self-consumption-connection-requests-title":
          "Collective Self-Consumption Connection Requests",
        "collective-self-consumption-connection-requests-desc":
          "Our specialized partner is directly integrated into your account for community creation and PMO. Conducting CAE requests and distribution keys.",
        "consuel-certificate-visa-requests-title":
          "Consuel Certificate Visa Requests",
        "consuel-certificate-visa-requests-desc":
          "Filing the SC144-A, SC144-B, or SC144-C, preparing the one-line electrical diagram, then submitting the Blue or Violet Conformity Certificate (for batteries).",
        "control-office-and-consuel-visa-title":
          "Control Office and Consuel Visa",
        "control-office-and-consuel-visa-desc":
          "Technical communication with accredited organizations and obtaining the DRE conformity report. Preparing the SC144, one-line electrical diagram, and submitting the Blue or Violet AC.",
        "large-scale-sending-title": "Sending Within 48 Hours on a Large Scale",
        "large-scale-sending-desc":
          "Our pioneering automation and robots generate documents and fill out online forms.",
        "real-time-tracking-title": "Real-time Dated Tracking",
        "real-time-tracking-desc":
          "Your secretariat can quickly initiate and then track the progress of procedures on the same software.",
        "additional-docs-title": "Processing Requests for Additional Documents",
        "additional-docs-desc":
          "Our study office processes requests for additional documents to unblock the files.",
        "follow-ups-title": "Follow-ups with Administrative Bodies",
        "follow-ups-desc":
          "Our project managers follow up with administrative bodies to reduce processing times.",
        "edf-obligation-title": "EDF Purchase Obligation",
        "edf-obligation-desc":
          "Carrying out the procedure with EDF OA, automatic Affidavit or the S21 'ENR' Certificate with Carbon Footprint (for systems over 100 kWc).",
        "virtual-battery-procedure-title": "Virtual Battery Approach",
        "virtual-battery-procedure-desc":
          "Carrying out the procedure with one of the three virtual battery providers - MyLight150, Urban Solar Energy, JPME - for virtual storage.",
        "financing-report-title": "Financing Profitability Report",
        "financing-report-desc":
          "Analyze the financing of the photovoltaic investment based on energy yield, from an hourly kWh calculation.",
        "payment-savings-title":
          "Monthly Payment and Savings Effort Calculation",
        "payment-savings-desc":
          "Compare the financing of the photovoltaic investment, whether in cash or through a bank loan, integrating your OPEX and EBITDA.",
        "solar-subscription-title": "Solar Subscription",
        "solar-subscription-desc":
          "Our partner specializing in subscriptions is directly integrated into your account. Make solar subscription financing requests from the study stage.",
        "creation-and-management-of-spvs-title":
          "Creation and Management of SPVs",
        "creation-and-management-of-spvs-desc":
          "Your team organizes project portfolios by SPV directly from your account. Our project managers can create the SIRET numbers and assist with notaries.",
        "mobile-assistance-for-technical-visits-title":
          "Mobile Assistance for Technical Visits",
        "mobile-assistance-for-technical-visits-desc":
          "Your technical sales representatives can easily fill in client forms and upload photos and information while on the move.",
        "material-planning-title": "Material Planning",
        "material-planning-desc":
          "Automatic inventory lists of equipment available per site and per flow, for controlling material and orders.",
        "integrated-calendar-title": "Integrated Calendar",
        "integrated-calendar-desc":
          "Each team member has access, from their own account, to the company calendar for planning travels and installations. Add Google Calendar or Microsoft Outlook.",
        "subcontractor-management-for-installers-title":
          "Subcontractor Management for Installers",
        "subcontractor-management-for-installers-desc":
          "Your technical documents can be shared directly from your account with your project partners, to facilitate installation, Consuel, and Control Bureau.",
        "client-relations-title": "Client Relations and CRM",
        "client-relations-desc":
          "Client assignments, comment space on client forms, file storage. Customizable automatic email notifications.",
        "team-access-title": "Team Access and Roles",
        "team-access-desc":
          "Sales, secretarial, and technical teams can each customize their interface. Managers have access to payments. Accounting has email access to invoices.",
        "integration-business-referrers-title":
          "Integration with Business Referrers",
        "integration-business-referrers-desc":
          "Business referrers only have access to their clients. Information visibility is customizable.",
        "custom-dashboard-title": "Customizable Dashboard",
        "custom-dashboard-desc":
          "Each team member can adjust their dashboard. Manage your sizing, studies, administrative procedures, and construction in one place.",
        "sales-cycle-tracking-title": "Sales Cycle Tracking and Reports",
        "sales-cycle-tracking-desc":
          "View key sales figures and activity in real-time. Our platform generates statistics of your projects. Receive automatic reports by email.",
        "data-export-title": "Data Export",
        "data-export-desc":
          "Need to analyze data in Excel? Need to secure the data? Export all tables and files in CSV format.",
        "as-built-files-title": "Automatic As-Built Files (DOE)",
        "as-built-files-desc":
          "Generate DOE reports in PDF or web format, shareable with clients and third parties for work acceptance reports and insurance audits.",
        "maintenance-contracts-title": "Maintenance Contracts",
        "maintenance-contracts-desc":
          "Help your clients schedule and pay for after-sales services (SAV) and maintenance contracts through online payment pages.",
        "white-label-title": "100% White Label",
        "white-label-desc":
          "Add your logo and main colors, buttons, and graphics. Customize the interfaces. Enhance your brand.",
        "white-label-client-portal-title": "White Label Client Portal",
        "white-label-client-portal-desc":
          "Invite your clients to an online space to view your study, sign your quote, and track the progress of their case. Your clients can enter information and documents.",
        "login-registration-pages-title":
          "Login and Registration Pages on Website",
        "login-registration-pages-desc":
          "Invite your clients to log into their white label client portal from your website.",
        "seo-title": "Search Engine Optimization and SEO",
        "seo-desc":
          "Fill in the customizable profile 'Our establishment' available on studies and in our directory.",
        "online-messaging-title": "Online Messaging",
        "online-messaging-desc":
          "Our team responds within minutes with written records.",
        "phone-support-title": "Phone Support",
        "phone-support-desc":
          "Our team is always available to assist you with your procedures.",
        "email-title": "Email",
        "email-desc":
          "Our team is available by email to facilitate your communications with third parties.",
        "video-conference-appointments-title": "Video Conference Appointments",
        "video-conference-appointments-desc":
          "Our team is here to listen and help you develop your follow-up together.",
        "file-transfer-title": "File Transfer",
        "file-transfer-desc":
          "Our IT teams assist you in migrating data and files to our system so you can manage operations.",
      },
      "project-contact": {
        title: "All your projects. A single specialist contact.",
        description:
          "Since 2020, our engineering department has built in-depth expertise and recognized know-how. Accelerate your projects and files with our automation solutions and your all-in-one project management platform.",
        "link-text": "Request your demo",
        services: {
          service1: {
            title: "All power ratings in kW and MW",
            description:
              "Our team of specialists will assist you with private, commercial, LV and HV projects.",
          },
          service2: {
            title: "All types of PV projects",
            description:
              "Rooftop solar projects, new construction, carports, small ground-mount? We can help you.",
          },
          service3: {
            title: "Throughout France",
            description:
              "In the French overseas departments and territories? We are present in Metropolitan France and in the overseas territories.",
          },
        },
      },
    },
    MANUFACTURER_SUPPLIER: {
      hero: {
        "icon-label": "Use case",
        "discover-solutions": "Discover solutions",
        "book-demo": "Request your demo",
        "name-orange": "Hardware supplier",
        "name-black": "distributing to solar industry",
        description:
          "Are you a hardware manufacturer or vendor? Discover how to sell directly to thousands of installers with projetsolaire.",
      },
      works: {
        heading: "How it works",
        title:
          "Digital platform for distributing hardware to the solar and storage sector",

        steps: {
          step1: {
            title: "Account registration",
            heading:
              "No commitment required. Quick and free online sign-up. Then, complete your account with your payment details, insurance, and other documents.",
          },
          step2: {
            title: "List your hardware",
            heading:
              "Select the hardware you are selling from our database. List your prices, your conditions, and stock availability.",
          },
          step3: {
            title: "Data transfer",
            heading:
              "Our technology teams will assist you in migrating data and documents to your system so that you can manage operations.",
          },
        },
      },
      "product-listing": {
        title: "All-in-one and à la carte solutions",
        description:
          "Discover the standard of the industry, recognized as No. 1 by hundreds of professionals.",
        button: "Learn more",
        connection: "Networking",
        "connection-desc":
          "Discover potential clients directly from your account, without paying commissions to business introducers.",
        "networking-title": "Networking",
        "networking-desc":
          "Discover potential clients directly from your account, without paying commissions to business introducers.",
        "project-management-assistance-title": "Project Management Assistance",
        "project-management-assistance-desc":
          "The project manager sets the price and materials. Benefit from the technical visit and electronic signature tools to accelerate your sales.",
        "3d-sizing-tool-title": "3D Sizing Tool",
        "3d-sizing-tool-desc":
          "We have integrated Aurora Solar to provide you with the most powerful and technically accurate photovoltaic yield solution.",
        "shading-masks-title": "Shading Masks Compliant with RGE Audit",
        "shading-masks-desc":
          "Opt for the precision of 0.10m LIDAR in 3D to perform sunlight assessments in kWh/m² throughout France.",
        "enedis-api-title": "Enedis API and Linky Meter Data",
        "enedis-api-desc":
          "We have integrated Aurora Solar to offer you the most powerful and technically accurate photovoltaic production solution.",
        "self-consumption-studies-title":
          "Self-consumption or full-sale studies",
        "self-consumption-studies-desc":
          "Offer extraordinary and complete studies, with an unlimited number of techno-financial proposals per study.",
        "virtual-battery-comparison-title":
          "Virtual Battery Comparison Studies",
        "virtual-battery-comparison-desc":
          "Compare the profitability of the EDF OA contract with virtual battery providers MyLight150, Urban Solar Energy, JPME.",
        "physical-battery-studies-title": "Physical Battery Studies",
        "physical-battery-studies-desc":
          "Add a physical battery model and technical sheet for hourly analysis of self-consumption and storage profitability.",
        "techno-financial-profitability-studies-title":
          "Techno-financial Profitability Studies",
        "techno-financial-profitability-studies-desc":
          "Define the business plan for the budget. Calculate financial forecasts over 25 years. Analyze the cash flow table for the investment over the life of the project.",
        "edf-oa-purchase-tariff-title":
          "Watch the EDF OA purchase tariff in mainland France and ZNI",
        "edf-oa-purchase-tariff-desc":
          "The state premiums and purchase tariffs of our studies are updated every quarter with the new tariff decrees from the CRE.",
        "purchase-tariff-comparison-title":
          "Comparison of purchase tariffs by T-0",
        "purchase-tariff-comparison-desc":
          "Compare the profitability of photovoltaic plants with state aid across different quarters to speed up your sales.",
        "credit-financing-simulator-title": "Credit and Financing Simulator",
        "credit-financing-simulator-desc":
          "Analyze the investment in cash, through a loan, or through roof leasing - directly integrated into the study.",
        "enedis-costs-simulator-title": "Enedis Costs Simulator",
        "enedis-costs-simulator-desc":
          "Estimate the costs of reinforcing the electrical network based on Enedis' billing scale. The only alternative to the PTF in France.",
        "white-label-support-formats-title":
          "All support formats in white label",
        "white-label-support-formats-desc":
          "Studies in interactive mini-site, PDF, spreadsheet, or mobile format.",
        "quotes-with-integrated-materials-title":
          "Quotes with integrated materials",
        "quotes-with-integrated-materials-desc":
          "Prepare your quotes from a database with thousands of modules, inverters, enclosures, batteries.",
        "accounting-numbering-of-quotes-title":
          "Accounting numbering of quotes",
        "accounting-numbering-of-quotes-desc":
          "Also customize your colors, your general terms and conditions, technical sheets, VAT certificate, and much more for your quotes.",
        "legally-compliant-electronic-signatures-title":
          "Legally compliant electronic signatures",
        "legally-compliant-electronic-signatures-desc":
          "Write and have your quotes signed online, with your references and mentions. Access your quotes and documents in your account.",
        "accounting-invoices-for-deposits-and-balances-title":
          "Accounting invoices for deposits and balances",
        "accounting-invoices-for-deposits-and-balances-desc":
          "Define your deposits, manage your transactions, add your invoices, and much more.",
        "secure-payments-by-bank-transfer-or-credit-card-title":
          "Secure payments by bank transfer or credit card",
        "secure-payments-by-bank-transfer-or-credit-card-desc":
          "Receive your payments via simple payment pages, with several payment methods, integrated into your quotes and invoices.",
        "10000-plus-product-references-title":
          "10,000+ product references: modules, inverters, cabinets, batteries ...",
        "10000-plus-product-references-desc":
          "Choose the product model from our real-time updated database. Save your kits and equipment lists for reduced quote and procedure input.",
        "project-material-lists-title": "Project material lists",
        "project-material-lists-desc":
          "Automatic planning of product and equipment lists for photovoltaic installations.",
        "technical-datasheets-compliance-certificates-and-carbon-footprint-report-title":
          "Technical datasheets, Compliance Certificates, and Carbon Footprint Report",
        "technical-datasheets-compliance-certificates-and-carbon-footprint-report-desc":
          "Our database contains thousands of up-to-date documents for your procedures.",
        "professional-technical-documentation-title":
          "Professional technical documentation",
        "professional-technical-documentation-desc":
          "Automatically generate wiring diagrams, Strapping certificates, and Execution plans.",
        "material-ordering-title": "Material ordering",
        "material-ordering-desc":
          "Request quotes from manufacturers and distributors to find competitive prices online.",
        "urban-planning-authorization-requests-title":
          "Urban Planning Authorization Requests",
        "urban-planning-authorization-requests-desc":
          "Filing the Preliminary Declaration or Building Permit for your photovoltaic installation with the relevant local authorities for approval at the town hall.",
        "gracious-appeal-and-daact-title": "Gracious Appeal and DAACT",
        "gracious-appeal-and-daact-desc":
          "Filing the DAACT for your photovoltaic installation with the relevant local authorities. In case of refusal, filing the gracious appeal.",
        "communication-with-architects-title": "Communication with Architects",
        "communication-with-architects-desc":
          "Conducting PLU/RNU feasibility studies, preparing graphic documents, architect certification, and submission at the town hall as required by architect regulations.",
        "connection-requests-title": "Connection Requests",
        "connection-requests-desc":
          "Obtaining the CAE contract and commissioning your photovoltaic installation with the electrical network operator Enedis or local ELD operator.",
        "low-or-medium-voltage-connection-requests-title":
          "Low or Medium Voltage Connection Requests",
        "low-or-medium-voltage-connection-requests-desc":
          "Obtaining the PTF and CACS-i contract, then commissioning your photovoltaic installation with the electrical network operator Enedis or local ELD operator.",
        "collective-self-consumption-connection-requests-title":
          "Collective Self-Consumption Connection Requests",
        "collective-self-consumption-connection-requests-desc":
          "Our specialized partner is directly integrated into your account for community creation and PMO. Conducting CAE requests and distribution keys.",
        "consuel-certificate-visa-requests-title":
          "Consuel Certificate Visa Requests",
        "consuel-certificate-visa-requests-desc":
          "Filing the SC144-A, SC144-B, or SC144-C, preparing the one-line electrical diagram, then submitting the Blue or Violet Conformity Certificate (for batteries).",
        "control-office-and-consuel-visa-title":
          "Control Office and Consuel Visa",
        "control-office-and-consuel-visa-desc":
          "Technical communication with accredited organizations and obtaining the DRE conformity report. Preparing the SC144, one-line electrical diagram, and submitting the Blue or Violet AC.",
        "large-scale-sending-title": "Sending Within 48 Hours on a Large Scale",
        "large-scale-sending-desc":
          "Our pioneering automation and robots generate documents and fill out online forms.",
        "real-time-tracking-title": "Real-time Dated Tracking",
        "real-time-tracking-desc":
          "Your secretariat can quickly initiate and then track the progress of procedures on the same software.",
        "additional-docs-title": "Processing Requests for Additional Documents",
        "additional-docs-desc":
          "Our study office processes requests for additional documents to unblock the files.",
        "follow-ups-title": "Follow-ups with Administrative Bodies",
        "follow-ups-desc":
          "Our project managers follow up with administrative bodies to reduce processing times.",
        "edf-obligation-title": "EDF Purchase Obligation",
        "edf-obligation-desc":
          "Carrying out the procedure with EDF OA, automatic Affidavit or the S21 'ENR' Certificate with Carbon Footprint (for systems over 100 kWc).",
        "virtual-battery-procedure-title": "Virtual Battery Approach",
        "virtual-battery-procedure-desc":
          "Carrying out the procedure with one of the three virtual battery providers - MyLight150, Urban Solar Energy, JPME - for virtual storage.",
        "financing-report-title": "Financing Profitability Report",
        "financing-report-desc":
          "Analyze the financing of the photovoltaic investment based on energy yield, from an hourly kWh calculation.",
        "payment-savings-title":
          "Monthly Payment and Savings Effort Calculation",
        "payment-savings-desc":
          "Compare the financing of the photovoltaic investment, whether in cash or through a bank loan, integrating your OPEX and EBITDA.",
        "solar-subscription-title": "Solar Subscription",
        "solar-subscription-desc":
          "Our partner specializing in subscriptions is directly integrated into your account. Make solar subscription financing requests from the study stage.",
        "creation-and-management-of-spvs-title":
          "Creation and Management of SPVs",
        "creation-and-management-of-spvs-desc":
          "Your team organizes project portfolios by SPV directly from your account. Our project managers can create the SIRET numbers and assist with notaries.",
        "mobile-assistance-for-technical-visits-title":
          "Mobile Assistance for Technical Visits",
        "mobile-assistance-for-technical-visits-desc":
          "Your technical sales representatives can easily fill in client forms and upload photos and information while on the move.",
        "material-planning-title": "Material Planning",
        "material-planning-desc":
          "Automatic inventory lists of equipment available per site and per flow, for controlling material and orders.",
        "integrated-calendar-title": "Integrated Calendar",
        "integrated-calendar-desc":
          "Each team member has access, from their own account, to the company calendar for planning travels and installations. Add Google Calendar or Microsoft Outlook.",
        "subcontractor-management-for-installers-title":
          "Subcontractor Management for Installers",
        "subcontractor-management-for-installers-desc":
          "Your technical documents can be shared directly from your account with your project partners, to facilitate installation, Consuel, and Control Bureau.",
        "client-relations-title": "Client Relations and CRM",
        "client-relations-desc":
          "Client assignments, comment space on client forms, file storage. Customizable automatic email notifications.",
        "team-access-title": "Team Access and Roles",
        "team-access-desc":
          "Sales, secretarial, and technical teams can each customize their interface. Managers have access to payments. Accounting has email access to invoices.",
        "integration-business-referrers-title":
          "Integration with Business Referrers",
        "integration-business-referrers-desc":
          "Business referrers only have access to their clients. Information visibility is customizable.",
        "custom-dashboard-title": "Customizable Dashboard",
        "custom-dashboard-desc":
          "Each team member can adjust their dashboard. Manage your sizing, studies, administrative procedures, and construction in one place.",
        "sales-cycle-tracking-title": "Sales Cycle Tracking and Reports",
        "sales-cycle-tracking-desc":
          "View key sales figures and activity in real-time. Our platform generates statistics of your projects. Receive automatic reports by email.",
        "data-export-title": "Data Export",
        "data-export-desc":
          "Need to analyze data in Excel? Need to secure the data? Export all tables and files in CSV format.",
        "as-built-files-title": "Automatic As-Built Files (DOE)",
        "as-built-files-desc":
          "Generate DOE reports in PDF or web format, shareable with clients and third parties for work acceptance reports and insurance audits.",
        "maintenance-contracts-title": "Maintenance Contracts",
        "maintenance-contracts-desc":
          "Help your clients schedule and pay for after-sales services (SAV) and maintenance contracts through online payment pages.",
        "white-label-title": "100% White Label",
        "white-label-desc":
          "Add your logo and main colors, buttons, and graphics. Customize the interfaces. Enhance your brand.",
        "white-label-client-portal-title": "White Label Client Portal",
        "white-label-client-portal-desc":
          "Invite your clients to an online space to view your study, sign your quote, and track the progress of their case. Your clients can enter information and documents.",
        "login-registration-pages-title":
          "Login and Registration Pages on Website",
        "login-registration-pages-desc":
          "Invite your clients to log into their white label client portal from your website.",
        "seo-title": "Search Engine Optimization and SEO",
        "seo-desc":
          "Fill in the customizable profile 'Our establishment' available on studies and in our directory.",
        "online-messaging-title": "Online Messaging",
        "online-messaging-desc":
          "Our team responds within minutes with written records.",
        "phone-support-title": "Phone Support",
        "phone-support-desc":
          "Our team is always available to assist you with your procedures.",
        "email-title": "Email",
        "email-desc":
          "Our team is available by email to facilitate your communications with third parties.",
        "video-conference-appointments-title": "Video Conference Appointments",
        "video-conference-appointments-desc":
          "Our team is here to listen and help you develop your follow-up together.",
        "file-transfer-title": "File Transfer",
        "file-transfer-desc":
          "Our IT teams assist you in migrating data and files to our system so you can manage operations.",
      },
      "project-contact": {
        title: "All your projects. A single specialist contact.",
        description:
          "Since 2020, our engineering department has built in-depth expertise and recognized know-how. Accelerate your projects and files with our automation solutions and your all-in-one project management platform.",
        "link-text": "Request your demo",
        services: {
          service1: {
            title: "All power ratings in kW and MW",
            description:
              "Our team of specialists will assist you with private, commercial, LV and HV projects.",
          },
          service2: {
            title: "All types of PV projects",
            description:
              "Rooftop solar projects, new construction, carports, small ground-mount? We can help you.",
          },
          service3: {
            title: "Throughout France",
            description:
              "In the French overseas departments and territories? We are present in Metropolitan France and in the overseas territories.",
          },
        },
      },
    },
    ENERGY_SUPPLIER: {
      hero: {
        "icon-label": "Use cases",
        "discover-solutions": "Discover solutions",
        "book-demo": "Request your demo",
        "name-orange": "Energy supplier",
        "name-black": "present in solar",
        description:
          "Do you offer EMS solutions? Discover how energy suppliers use projetsolaire to innovate faster.",
      },
      works: {
        heading: "How it works",
        title:
          "Platform for distributing innovations to the solar and storage industry",

        steps: {
          step1: {
            title: "White-label integration",
            heading:
              "Our IT teams support you in integrating your bespoke digital solutions into our digital platform.",
          },
          step2: {
            title: "Steering committee kick-off",
            heading:
              "Service organization around detailed reports and bi-monthly meetings with a single point of contact and project managers.",
          },
          step3: {
            title: "Data transfer",
            heading:
              "Our IT teams support you in migrating data and files to your system so you can run day-to-day operations.",
          },
        },
      },
      "product-listing": {
        title: "All-in-one and à la carte solutions",
        description:
          "Discover the standard of the industry, recognized as No. 1 by hundreds of professionals.",
        button: "Learn more",
        connection: "Networking",
        "connection-desc":
          "Discover potential clients directly from your account, without paying commissions to business introducers.",
        "networking-title": "Networking",
        "networking-desc":
          "Discover potential clients directly from your account, without paying commissions to business introducers.",
        "project-management-assistance-title": "Project Management Assistance",
        "project-management-assistance-desc":
          "The project manager sets the price and materials. Benefit from the technical visit and electronic signature tools to accelerate your sales.",
        "3d-sizing-tool-title": "3D Sizing Tool",
        "3d-sizing-tool-desc":
          "We have integrated Aurora Solar to provide you with the most powerful and technically accurate photovoltaic yield solution.",
        "shading-masks-title": "Shading Masks Compliant with RGE Audit",
        "shading-masks-desc":
          "Opt for the precision of 0.10m LIDAR in 3D to perform sunlight assessments in kWh/m² throughout France.",
        "enedis-api-title": "Enedis API and Linky Meter Data",
        "enedis-api-desc":
          "We have integrated Aurora Solar to offer you the most powerful and technically accurate photovoltaic production solution.",
        "self-consumption-studies-title":
          "Self-consumption or full-sale studies",
        "self-consumption-studies-desc":
          "Offer extraordinary and complete studies, with an unlimited number of techno-financial proposals per study.",
        "virtual-battery-comparison-title":
          "Virtual Battery Comparison Studies",
        "virtual-battery-comparison-desc":
          "Compare the profitability of the EDF OA contract with virtual battery providers MyLight150, Urban Solar Energy, JPME.",
        "physical-battery-studies-title": "Physical Battery Studies",
        "physical-battery-studies-desc":
          "Add a physical battery model and technical sheet for hourly analysis of self-consumption and storage profitability.",
        "techno-financial-profitability-studies-title":
          "Techno-financial Profitability Studies",
        "techno-financial-profitability-studies-desc":
          "Define the business plan for the budget. Calculate financial forecasts over 25 years. Analyze the cash flow table for the investment over the life of the project.",
        "edf-oa-purchase-tariff-title":
          "Watch the EDF OA purchase tariff in mainland France and ZNI",
        "edf-oa-purchase-tariff-desc":
          "The state premiums and purchase tariffs of our studies are updated every quarter with the new tariff decrees from the CRE.",
        "purchase-tariff-comparison-title":
          "Comparison of purchase tariffs by T-0",
        "purchase-tariff-comparison-desc":
          "Compare the profitability of photovoltaic plants with state aid across different quarters to speed up your sales.",
        "credit-financing-simulator-title": "Credit and Financing Simulator",
        "credit-financing-simulator-desc":
          "Analyze the investment in cash, through a loan, or through roof leasing - directly integrated into the study.",
        "enedis-costs-simulator-title": "Enedis Costs Simulator",
        "enedis-costs-simulator-desc":
          "Estimate the costs of reinforcing the electrical network based on Enedis' billing scale. The only alternative to the PTF in France.",
        "white-label-support-formats-title":
          "All support formats in white label",
        "white-label-support-formats-desc":
          "Studies in interactive mini-site, PDF, spreadsheet, or mobile format.",
        "quotes-with-integrated-materials-title":
          "Quotes with integrated materials",
        "quotes-with-integrated-materials-desc":
          "Prepare your quotes from a database with thousands of modules, inverters, enclosures, batteries.",
        "accounting-numbering-of-quotes-title":
          "Accounting numbering of quotes",
        "accounting-numbering-of-quotes-desc":
          "Also customize your colors, your general terms and conditions, technical sheets, VAT certificate, and much more for your quotes.",
        "legally-compliant-electronic-signatures-title":
          "Legally compliant electronic signatures",
        "legally-compliant-electronic-signatures-desc":
          "Write and have your quotes signed online, with your references and mentions. Access your quotes and documents in your account.",
        "accounting-invoices-for-deposits-and-balances-title":
          "Accounting invoices for deposits and balances",
        "accounting-invoices-for-deposits-and-balances-desc":
          "Define your deposits, manage your transactions, add your invoices, and much more.",
        "secure-payments-by-bank-transfer-or-credit-card-title":
          "Secure payments by bank transfer or credit card",
        "secure-payments-by-bank-transfer-or-credit-card-desc":
          "Receive your payments via simple payment pages, with several payment methods, integrated into your quotes and invoices.",
        "10000-plus-product-references-title":
          "10,000+ product references: modules, inverters, cabinets, batteries ...",
        "10000-plus-product-references-desc":
          "Choose the product model from our real-time updated database. Save your kits and equipment lists for reduced quote and procedure input.",
        "project-material-lists-title": "Project material lists",
        "project-material-lists-desc":
          "Automatic planning of product and equipment lists for photovoltaic installations.",
        "technical-datasheets-compliance-certificates-and-carbon-footprint-report-title":
          "Technical datasheets, Compliance Certificates, and Carbon Footprint Report",
        "technical-datasheets-compliance-certificates-and-carbon-footprint-report-desc":
          "Our database contains thousands of up-to-date documents for your procedures.",
        "professional-technical-documentation-title":
          "Professional technical documentation",
        "professional-technical-documentation-desc":
          "Automatically generate wiring diagrams, Strapping certificates, and Execution plans.",
        "material-ordering-title": "Material ordering",
        "material-ordering-desc":
          "Request quotes from manufacturers and distributors to find competitive prices online.",
        "urban-planning-authorization-requests-title":
          "Urban Planning Authorization Requests",
        "urban-planning-authorization-requests-desc":
          "Filing the Preliminary Declaration or Building Permit for your photovoltaic installation with the relevant local authorities for approval at the town hall.",
        "gracious-appeal-and-daact-title": "Gracious Appeal and DAACT",
        "gracious-appeal-and-daact-desc":
          "Filing the DAACT for your photovoltaic installation with the relevant local authorities. In case of refusal, filing the gracious appeal.",
        "communication-with-architects-title": "Communication with Architects",
        "communication-with-architects-desc":
          "Conducting PLU/RNU feasibility studies, preparing graphic documents, architect certification, and submission at the town hall as required by architect regulations.",
        "connection-requests-title": "Connection Requests",
        "connection-requests-desc":
          "Obtaining the CAE contract and commissioning your photovoltaic installation with the electrical network operator Enedis or local ELD operator.",
        "low-or-medium-voltage-connection-requests-title":
          "Low or Medium Voltage Connection Requests",
        "low-or-medium-voltage-connection-requests-desc":
          "Obtaining the PTF and CACS-i contract, then commissioning your photovoltaic installation with the electrical network operator Enedis or local ELD operator.",
        "collective-self-consumption-connection-requests-title":
          "Collective Self-Consumption Connection Requests",
        "collective-self-consumption-connection-requests-desc":
          "Our specialized partner is directly integrated into your account for community creation and PMO. Conducting CAE requests and distribution keys.",
        "consuel-certificate-visa-requests-title":
          "Consuel Certificate Visa Requests",
        "consuel-certificate-visa-requests-desc":
          "Filing the SC144-A, SC144-B, or SC144-C, preparing the one-line electrical diagram, then submitting the Blue or Violet Conformity Certificate (for batteries).",
        "control-office-and-consuel-visa-title":
          "Control Office and Consuel Visa",
        "control-office-and-consuel-visa-desc":
          "Technical communication with accredited organizations and obtaining the DRE conformity report. Preparing the SC144, one-line electrical diagram, and submitting the Blue or Violet AC.",
        "large-scale-sending-title": "Sending Within 48 Hours on a Large Scale",
        "large-scale-sending-desc":
          "Our pioneering automation and robots generate documents and fill out online forms.",
        "real-time-tracking-title": "Real-time Dated Tracking",
        "real-time-tracking-desc":
          "Your secretariat can quickly initiate and then track the progress of procedures on the same software.",
        "additional-docs-title": "Processing Requests for Additional Documents",
        "additional-docs-desc":
          "Our study office processes requests for additional documents to unblock the files.",
        "follow-ups-title": "Follow-ups with Administrative Bodies",
        "follow-ups-desc":
          "Our project managers follow up with administrative bodies to reduce processing times.",
        "edf-obligation-title": "EDF Purchase Obligation",
        "edf-obligation-desc":
          "Carrying out the procedure with EDF OA, automatic Affidavit or the S21 'ENR' Certificate with Carbon Footprint (for systems over 100 kWc).",
        "virtual-battery-procedure-title": "Virtual Battery Approach",
        "virtual-battery-procedure-desc":
          "Carrying out the procedure with one of the three virtual battery providers - MyLight150, Urban Solar Energy, JPME - for virtual storage.",
        "financing-report-title": "Financing Profitability Report",
        "financing-report-desc":
          "Analyze the financing of the photovoltaic investment based on energy yield, from an hourly kWh calculation.",
        "payment-savings-title":
          "Monthly Payment and Savings Effort Calculation",
        "payment-savings-desc":
          "Compare the financing of the photovoltaic investment, whether in cash or through a bank loan, integrating your OPEX and EBITDA.",
        "solar-subscription-title": "Solar Subscription",
        "solar-subscription-desc":
          "Our partner specializing in subscriptions is directly integrated into your account. Make solar subscription financing requests from the study stage.",
        "creation-and-management-of-spvs-title":
          "Creation and Management of SPVs",
        "creation-and-management-of-spvs-desc":
          "Your team organizes project portfolios by SPV directly from your account. Our project managers can create the SIRET numbers and assist with notaries.",
        "mobile-assistance-for-technical-visits-title":
          "Mobile Assistance for Technical Visits",
        "mobile-assistance-for-technical-visits-desc":
          "Your technical sales representatives can easily fill in client forms and upload photos and information while on the move.",
        "material-planning-title": "Material Planning",
        "material-planning-desc":
          "Automatic inventory lists of equipment available per site and per flow, for controlling material and orders.",
        "integrated-calendar-title": "Integrated Calendar",
        "integrated-calendar-desc":
          "Each team member has access, from their own account, to the company calendar for planning travels and installations. Add Google Calendar or Microsoft Outlook.",
        "subcontractor-management-for-installers-title":
          "Subcontractor Management for Installers",
        "subcontractor-management-for-installers-desc":
          "Your technical documents can be shared directly from your account with your project partners, to facilitate installation, Consuel, and Control Bureau.",
        "client-relations-title": "Client Relations and CRM",
        "client-relations-desc":
          "Client assignments, comment space on client forms, file storage. Customizable automatic email notifications.",
        "team-access-title": "Team Access and Roles",
        "team-access-desc":
          "Sales, secretarial, and technical teams can each customize their interface. Managers have access to payments. Accounting has email access to invoices.",
        "integration-business-referrers-title":
          "Integration with Business Referrers",
        "integration-business-referrers-desc":
          "Business referrers only have access to their clients. Information visibility is customizable.",
        "custom-dashboard-title": "Customizable Dashboard",
        "custom-dashboard-desc":
          "Each team member can adjust their dashboard. Manage your sizing, studies, administrative procedures, and construction in one place.",
        "sales-cycle-tracking-title": "Sales Cycle Tracking and Reports",
        "sales-cycle-tracking-desc":
          "View key sales figures and activity in real-time. Our platform generates statistics of your projects. Receive automatic reports by email.",
        "data-export-title": "Data Export",
        "data-export-desc":
          "Need to analyze data in Excel? Need to secure the data? Export all tables and files in CSV format.",
        "as-built-files-title": "Automatic As-Built Files (DOE)",
        "as-built-files-desc":
          "Generate DOE reports in PDF or web format, shareable with clients and third parties for work acceptance reports and insurance audits.",
        "maintenance-contracts-title": "Maintenance Contracts",
        "maintenance-contracts-desc":
          "Help your clients schedule and pay for after-sales services (SAV) and maintenance contracts through online payment pages.",
        "white-label-title": "100% White Label",
        "white-label-desc":
          "Add your logo and main colors, buttons, and graphics. Customize the interfaces. Enhance your brand.",
        "white-label-client-portal-title": "White Label Client Portal",
        "white-label-client-portal-desc":
          "Invite your clients to an online space to view your study, sign your quote, and track the progress of their case. Your clients can enter information and documents.",
        "login-registration-pages-title":
          "Login and Registration Pages on Website",
        "login-registration-pages-desc":
          "Invite your clients to log into their white label client portal from your website.",
        "seo-title": "Search Engine Optimization and SEO",
        "seo-desc":
          "Fill in the customizable profile 'Our establishment' available on studies and in our directory.",
        "online-messaging-title": "Online Messaging",
        "online-messaging-desc":
          "Our team responds within minutes with written records.",
        "phone-support-title": "Phone Support",
        "phone-support-desc":
          "Our team is always available to assist you with your procedures.",
        "email-title": "Email",
        "email-desc":
          "Our team is available by email to facilitate your communications with third parties.",
        "video-conference-appointments-title": "Video Conference Appointments",
        "video-conference-appointments-desc":
          "Our team is here to listen and help you develop your follow-up together.",
        "file-transfer-title": "File Transfer",
        "file-transfer-desc":
          "Our IT teams assist you in migrating data and files to our system so you can manage operations.",
      },
      "project-contact": {
        title: "All your projects. A single specialist contact.",
        description:
          "Since 2020, our engineering department has built in-depth expertise and recognized know-how. Accelerate your projects and files with our automation solutions and your all-in-one project management platform.",
        "link-text": "Request your demo",
        services: {
          service1: {
            title: "All power ratings in kW and MW",
            description:
              "Our team of specialists will assist you with private, commercial, LV and HV projects.",
          },
          service2: {
            title: "All types of PV projects",
            description:
              "Rooftop solar projects, new construction, carports, small ground-mount? We can help you.",
          },
          service3: {
            title: "Throughout France",
            description:
              "In the French overseas departments and territories? We are present in Metropolitan France and in the overseas territories.",
          },
        },
      },
    },
    SELF_INSTALLATION: {
      hero: {
        "icon-label": "Case Studies",
        "discover-solutions": "Discover Solutions",
        "book-demo": "Book a Demo",
        "name-orange": "Online Brand",
        "name-black": "offering services",
        description:
          "Are you a company offering a plug & play (solar kit) or DIY (Do It Yourself) solution across France? Discover how to sell online support services.",
      },
      works: {
        heading: "How it works",
        title:
          "Digital study office adapted for innovative and 100% online sales.",

        steps: {
          step1: {
            title: "Account personalization",
            heading:
              "Quick and free online registration. No commitment. Then, customize your colors, company presentation, and brand image.",
          },
          step2: {
            title: "White-label integration",
            heading:
              "Our IT teams assist you in integrating the registration pages, login pages, and photovoltaic customer portal into your website.",
          },
          step3: {
            title: "Add services a la carte",
            heading:
              "Need to do layouts? Full studies with quotes? Or municipal agreements? Use only what you need.",
          },
        },
      },
      "product-listing": {
        "networking-title": "Networking",
        "networking-desc":
          "Discover potential clients directly from your account, without paying commissions to business introducers.",
        "project-management-assistance-title": "Project Management Assistance",
        "project-management-assistance-desc":
          "The project manager sets the price and materials. Benefit from the technical visit and electronic signature tools to accelerate your sales.",
        "3d-sizing-tool-title": "3D Sizing Tool",
        "3d-sizing-tool-desc":
          "We have integrated Aurora Solar to provide you with the most powerful and technically accurate photovoltaic yield solution.",
        "shading-masks-compliant-with-rge-audit-title":
          "Shading Masks Compliant with RGE Audit",
        "shading-masks-compliant-with-rge-audit-desc":
          "Opt for the precision of 0.10m LIDAR in 3D to perform sunlight assessments in kWh/m² throughout France.",
        "enedis-api-title": "Enedis API and Linky Meter Data",
        "enedis-api-desc":
          "We have integrated Aurora Solar to offer you the most powerful and technically accurate photovoltaic production solution.",
        "self-consumption-or-full-sale-studies-title":
          "Self-consumption or full-sale studies",
        "self-consumption-or-full-sale-studies-desc":
          "Offer extraordinary and complete studies, with an unlimited number of techno-financial proposals per study.",
        "virtual-battery-comparison-studies-title":
          "Virtual Battery Comparison Studies",
        "virtual-battery-comparison-studies-desc":
          "Compare the profitability of the EDF OA contract with virtual battery providers MyLight150, Urban Solar Energy, JPME.",
        "physical-battery-studies-title": "Physical Battery Studies",
        "physical-battery-studies-desc":
          "Add a physical battery model and technical sheet for hourly analysis of self-consumption and storage profitability.",
        "techno-financial-profitability-studies-title":
          "Techno-financial Profitability Studies",
        "techno-financial-profitability-studies-desc":
          "Define the business plan for the budget. Calculate financial forecasts over 25 years. Analyze the cash flow table for the investment over the life of the project.",
        "watch-the-edf-oa-purchase-tariff-title":
          "Watch the EDF OA purchase tariff in mainland France and ZNI",
        "watch-the-edf-oa-purchase-tariff-desc":
          "The state premiums and purchase tariffs of our studies are updated every quarter with the new tariff decrees from the CRE.",
        "credit-and-financing-simulator-title":
          "Credit and Financing Simulator",
        "credit-and-financing-simulator-desc":
          "Analyze the investment in cash, through a loan, or through roof leasing - directly integrated into the study.",
        "all-support-formats-in-white-label-title":
          "All support formats in white label",
        "all-support-formats-in-white-label-desc":
          "Studies in interactive mini-site, PDF, spreadsheet, or mobile format.",
        "quotes-with-integrated-materials-title":
          "Quotes with integrated materials",
        "quotes-with-integrated-materials-desc":
          "Prepare your quotes from a database with thousands of modules, inverters, enclosures, batteries.",
        "accounting-numbering-of-quotes-title":
          "Accounting numbering of quotes",
        "accounting-numbering-of-quotes-desc":
          "Also customize your colors, your general terms and conditions, technical sheets, VAT certificate, and much more for your quotes.",
        "legally-compliant-electronic-signatures-title":
          "Legally compliant electronic signatures",
        "legally-compliant-electronic-signatures-desc":
          "Write and have your quotes signed online, with your references and mentions. Access your quotes and documents in your account.",
        "accounting-invoices-for-deposits-and-balances-title":
          "Accounting invoices for deposits and balances",
        "accounting-invoices-for-deposits-and-balances-desc":
          "Define your deposits, manage your transactions, add your invoices, and much more.",
        "secure-payments-by-bank-transfer-or-credit-card-title":
          "Secure payments by bank transfer or credit card",
        "secure-payments-by-bank-transfer-or-credit-card-desc":
          "Receive your payments via simple payment pages, with several payment methods, integrated into your quotes and invoices.",
        "10000-product-references-title":
          "10,000+ product references: modules, inverters, cabinets, batteries ...",
        "10000-product-references-desc":
          "Choose the product model from our real-time updated database. Save your kits and equipment lists for reduced quote and procedure input.",
        "project-material-lists-title": "Project material lists",
        "project-material-lists-desc":
          "Automatic planning of product and equipment lists for photovoltaic installations.",
        "technical-datasheets-compliance-certificates-carbon-footprint-report-title":
          "Technical datasheets, Compliance Certificates, and Carbon Footprint Report",
        "technical-datasheets-compliance-certificates-carbon-footprint-report-desc":
          "Our database contains thousands of up-to-date documents for your procedures.",
        "professional-technical-documentation-title":
          "Professional technical documentation",
        "professional-technical-documentation-desc":
          "Automatically generate wiring diagrams, Strapping certificates, and Execution plans.",
        "material-ordering-title": "Material ordering",
        "material-ordering-desc":
          "Request quotes from manufacturers and distributors to find competitive prices online.",
        "urban-planning-authorization-requests-title":
          "Urban Planning Authorization Requests",
        "urban-planning-authorization-requests-desc":
          "Filing the Preliminary Declaration or Building Permit for your photovoltaic installation with the relevant local authorities for approval at the town hall.",
        "gracious-appeal-and-daact-title": "Gracious Appeal and DAACT",
        "gracious-appeal-and-daact-desc":
          "Filing the DAACT for your photovoltaic installation with the relevant local authorities. In case of refusal, filing the gracious appeal.",
        "connection-requests-title": "Connection Requests",
        "connection-requests-desc":
          "Obtaining the CAE contract and commissioning your photovoltaic installation with the electrical network operator Enedis or local ELD operator.",
        "consuel-certificate-visa-requests-title":
          "Consuel Certificate Visa Requests",
        "consuel-certificate-visa-requests-desc":
          "Filing the SC144-A, SC144-B, or SC144-C, preparing the one-line electrical diagram, then submitting the Blue or Violet Conformity Certificate (for batteries).",
        "sending-within-48-hours-on-a-large-scale-title":
          "Sending within 48 hours on a large scale",
        "sending-within-48-hours-on-a-large-scale-desc":
          "Our pioneering automation and robots generate documents and fill out online forms.",
        "real-time-dated-tracking-title": "Real-time dated tracking",
        "real-time-dated-tracking-desc":
          "Your secretariat can quickly initiate and then track the progress of procedures on the same software.",
        "processing-requests-for-additional-documents-title":
          "Processing requests for additional documents",
        "processing-requests-for-additional-documents-desc":
          "Our study office processes requests for additional documents to unblock the files.",
        "follow-ups-with-administrative-bodies-title":
          "Follow-ups with administrative bodies",
        "follow-ups-with-administrative-bodies-desc":
          "Our project managers follow up with administrative bodies to reduce processing times.",
        "edf-purchase-obligation-title": "EDF Purchase Obligation",
        "edf-purchase-obligation-desc":
          "Carrying out the procedure with EDF OA, automatic Affidavit or the S21 'ENR' Certificate with Carbon Footprint (for systems over 100 kWc).",
        "cacsi-procedure-title": "CACSI Procedure",
        "cacsi-procedure-desc":
          "Obtaining the CACSI contract and commissioning your photovoltaic installation with the network operator Enedis or local grid operator ELD.",
        "arpe-procedure-title": "ARPE Procedure",
        "arpe-procedure-desc":
          "Carrying out the procedure with an alternative buyer - Octopus Energie, Ekwateur, etc. - for PPE contracts and other purchase agreements.",
        "virtual-battery-procedure-title": "Virtual Battery Approach",
        "virtual-battery-procedure-desc":
          "Carrying out the procedure with one of the three virtual battery providers - MyLight150, Urban Solar Energy, JPME - for virtual storage.",
        "financing-r-title": "Financing Profitability Report",
        "financing-r-desc":
          "Analyze the financing of the photovoltaic investment based on energy yield, from an hourly kWh calculation.",
        "monthly-payment-and-savings-effort-calculation-title":
          "Monthly Payment and Savings Effort Calculation",
        "monthly-payment-and-savings-effort-calculation-desc":
          "Compare the financing of the photovoltaic investment, whether in cash or through a bank loan, integrating your OPEX and EBITDA.",
        "material-planning-title": "Material Planning",
        "material-planning-desc":
          "Automatic inventory lists of equipment available per site and per flow, for controlling material and orders.",
        "integrated-calendar-title": "Integrated Calendar",
        "integrated-calendar-desc":
          "Each team member has access, from their own account, to the company calendar for planning travels and installations. Add Google Calendar or Microsoft Outlook.",
        "sharing-sites-with-installers-title": "Sharing Sites with Installers",
        "sharing-sites-with-installers-desc":
          "Your technical documents can be shared directly from your account with your project partners, to facilitate construction, Consuel, and Control Bureau.",
        "client-relations-and-crm-title": "Client Relations and CRM",
        "client-relations-and-crm-desc":
          "Client assignments, comment space on client forms, file storage. Customizable automatic email notifications.",
        "team-access-and-roles-title": "Team Access and Roles",
        "team-access-and-roles-desc":
          "Sales, secretarial, and technical teams can each customize their interface. Managers have access to payments. Accounting has email access to invoices.",
        "integration-with-business-referrers-title":
          "Integration with Business Referrers",
        "integration-with-business-referrers-desc":
          "Business referrers only have access to their clients. Information visibility is customizable.",
        "customizable-dashboard-title": "Customizable Dashboard",
        "customizable-dashboard-desc":
          "Each team member can adjust their dashboard. Manage your sizing, studies, administrative procedures, and construction in one place.",
        "sales-cycle-tracking-and-reports-title":
          "Sales Cycle Tracking and Reports",
        "sales-cycle-tracking-and-reports-desc":
          "View key sales figures and activity in real-time. Our platform generates statistics of your projects. Receive automatic reports by email.",
        "data-export-title": "Data Export",
        "data-export-desc":
          "Need to analyze data in Excel? Need to secure the data? Export all tables and files in CSV format.",
        "automatic-as-built-files-title": "Automatic As-Built Files (DOE)",
        "automatic-as-built-files-desc":
          "Generate DOE reports in PDF or web format, shareable with clients and third parties for work acceptance reports and insurance audits.",
        "maintenance-contracts-title": "Maintenance Contracts",
        "maintenance-contracts-desc":
          "Help your clients schedule and pay for after-sales services (SAV) and maintenance contracts through online payment pages.",
        "white-label-title": "100% White Label",
        "white-label-desc":
          "Add your logo and main colors, buttons, and graphics. Customize the interfaces. Enhance your brand.",
        "white-label-client-portal-title": "White Label Client Portal",
        "white-label-client-portal-desc":
          "Invite your clients to an online space to view your study, sign your quote, and track the progress of their case. Your clients can enter information and documents.",
        "login-and-registration-pages-on-website-title":
          "Login and Registration Pages on Website",
        "login-and-registration-pages-on-website-desc":
          "Invite your clients to log into their white label client portal from your website.",
        "seo-title": "Search Engine Optimization and SEO",
        "seo-desc":
          "Fill in the customizable profile 'Our establishment' available on studies and in our directory.",
        "online-messaging-title": "Online Messaging",
        "online-messaging-desc":
          "Our team responds within minutes with written records.",
        "phone-support-title": "Phone Support",
        "phone-support-desc":
          "Our team is always available to assist you with your procedures.",
        "email-title": "Email",
        "email-desc":
          "Our team is available by email to facilitate your communications with third parties.",
        "video-conference-appointments-title": "Video Conference Appointments",
        "video-conference-appointments-desc":
          "Our team is here to listen and help you develop your follow-up together.",
        "file-transfer-title": "File Transfer",
        "file-transfer-desc":
          "Our IT teams assist you in migrating data and files to our system so you can manage operations.",
      },
    },
    FRANCHISE: {
      hero: {
        "icon-label": "Case Studies",
        "discover-solutions": "Discover Solutions",
        "book-demo": "Book a Demo",
        "name-orange": "Franchise network",
        "name-black": "with high added value",
        description:
          "Are you a company operating in franchise across the entire national territory, interested in the projects of the franchise network? Discover how to strengthen your offer.",
      },
      works: {
        heading: "How it works",
        title: "Digital study office designed for photovoltaic teams.",

        steps: {
          step1: {
            title: "Account opening",
            heading:
              "No commitment. Quick and free online registration. Then, customize your colors, company presentation, and brand image.",
          },
          step2: {
            title: "Franchise invitation",
            heading:
              "Our teams assist you in IT integrations. Your franchises are trained by our teams in IT solutions.",
          },
          step3: {
            title: "Service sharing",
            heading:
              "Buy IT solutions a la carte with the benefits of network strength. Thus, gain added value for your franchises.",
          },
        },
      },
      "product-listing": {
        "networking-title": "Networking",
        "networking-desc":
          "Discover potential clients directly from your account, without paying commissions to business introducers.",
        "project-management-assistance-title": "Project Management Assistance",
        "project-management-assistance-desc":
          "The project manager sets the price and materials. Benefit from the technical visit and electronic signature tools to accelerate your sales.",
        "3d-sizing-tool-title": "3D Sizing Tool",
        "3d-sizing-tool-desc":
          "We have integrated Aurora Solar to provide you with the most powerful and technically accurate photovoltaic yield solution.",
        "shading-masks-compliant-with-rge-audit-title":
          "Shading Masks Compliant with RGE Audit",
        "shading-masks-compliant-with-rge-audit-desc":
          "Opt for the precision of 0.10m LIDAR in 3D to perform sunlight assessments in kWh/m² throughout France.",
        "enedis-api-and-linky-meter-data-title":
          "Enedis API and Linky Meter Data",
        "enedis-api-and-linky-meter-data-desc":
          "We have integrated Aurora Solar to offer you the most powerful and technically accurate photovoltaic production solution.",
        "self-consumption-or-full-sale-studies-title":
          "Self-consumption or full-sale studies",
        "self-consumption-or-full-sale-studies-desc":
          "Offer extraordinary and complete studies, with an unlimited number of techno-financial proposals per study.",
        "virtual-battery-comparison-studies-title":
          "Virtual Battery Comparison Studies",
        "virtual-battery-comparison-studies-desc":
          "Compare the profitability of the EDF OA contract with virtual battery providers MyLight150, Urban Solar Energy, JPME.",
        "physical-battery-studies-title": "Physical Battery Studies",
        "physical-battery-studies-desc":
          "Add a physical battery model and technical sheet for hourly analysis of self-consumption and storage profitability.",
        "techno-financial-profitability-studies-title":
          "Techno-financial Profitability Studies",
        "techno-financial-profitability-studies-desc":
          "Define the business plan for the budget. Calculate financial forecasts over 25 years. Analyze the cash flow table for the investment over the life of the project.",
        "watch-the-edf-oa-purchase-tariff-title":
          "Watch the EDF OA purchase tariff in mainland France and ZNI",
        "watch-the-edf-oa-purchase-tariff-desc":
          "The state premiums and purchase tariffs of our studies are updated every quarter with the new tariff decrees from the CRE.",
        "credit-and-financing-simulator-title":
          "Credit and Financing Simulator",
        "credit-and-financing-simulator-desc":
          "Analyze the investment in cash, through a loan, or through roof leasing - directly integrated into the study.",
        "all-support-formats-in-white-label-title":
          "All support formats in white label",
        "all-support-formats-in-white-label-desc":
          "Studies in interactive mini-site, PDF, spreadsheet, or mobile format.",
        "quotes-with-integrated-materials-title":
          "Quotes with integrated materials",
        "quotes-with-integrated-materials-desc":
          "Prepare your quotes from a database with thousands of modules, inverters, enclosures, batteries.",
        "accounting-numbering-of-quotes-title":
          "Accounting numbering of quotes",
        "accounting-numbering-of-quotes-desc":
          "Also customize your colors, your general terms and conditions, technical sheets, VAT certificate, and much more for your quotes.",
        "legally-compliant-electronic-signatures-title":
          "Legally compliant electronic signatures",
        "legally-compliant-electronic-signatures-desc":
          "Write and have your quotes signed online, with your references and mentions. Access your quotes and documents in your account.",
        "accounting-invoices-for-deposits-and-balances-title":
          "Accounting invoices for deposits and balances",
        "accounting-invoices-for-deposits-and-balances-desc":
          "Define your deposits, manage your transactions, add your invoices, and much more.",
        "secure-payments-by-bank-transfer-or-credit-card-title":
          "Secure payments by bank transfer or credit card",
        "secure-payments-by-bank-transfer-or-credit-card-desc":
          "Receive your payments via simple payment pages, with several payment methods, integrated into your quotes and invoices.",
        "product-references-title":
          "10,000+ product references: modules, inverters, cabinets, batteries ...",
        "product-references-desc":
          "Choose the product model from our real-time updated database. Save your kits and equipment lists for reduced quote and procedure input.",
        "project-material-lists-title": "Project material lists",
        "project-material-lists-desc":
          "Automatic planning of product and equipment lists for photovoltaic installations.",
        "technical-datasheets-compliance-certificates-carbon-footprint-report-title":
          "Technical datasheets, Compliance Certificates, and Carbon Footprint Report",
        "technical-datasheets-compliance-certificates-carbon-footprint-report-desc":
          "Our database contains thousands of up-to-date documents for your procedures.",
        "professional-technical-documentation-title":
          "Professional technical documentation",
        "professional-technical-documentation-desc":
          "Automatically generate wiring diagrams, Strapping certificates, and Execution plans.",
        "material-ordering-title": "Material ordering",
        "material-ordering-desc":
          "Request quotes from manufacturers and distributors to find competitive prices online.",
        "urban-planning-authorization-requests-title":
          "Urban Planning Authorization Requests",
        "urban-planning-authorization-requests-desc":
          "Filing the Preliminary Declaration or Building Permit for your photovoltaic installation with the relevant local authorities for approval at the town hall.",
        "gracious-appeal-and-daact-title": "Gracious Appeal and DAACT",
        "gracious-appeal-and-daact-desc":
          "Filing the DAACT for your photovoltaic installation with the relevant local authorities. In case of refusal, filing the gracious appeal.",
        "communication-with-architects-title": "Communication with Architects",
        "communication-with-architects-desc":
          "Conducting PLU/RNU feasibility studies, preparing graphic documents, architect certification, and submission at the town hall as required by architect regulations.",
        "connection-requests-title": "Connection Requests",
        "connection-requests-desc":
          "Obtaining the CAE contract and commissioning your photovoltaic installation with the electrical network operator Enedis or local ELD operator.",
        "low-or-medium-voltage-connection-requests-title":
          "Low or Medium Voltage Connection Requests",
        "low-or-medium-voltage-connection-requests-desc":
          "Obtaining the PTF and CACS-i contract, then commissioning your photovoltaic installation with the electrical network operator Enedis or local ELD operator.",
        "collective-self-consumption-connection-requests-title":
          "Collective Self-Consumption Connection Requests",
        "collective-self-consumption-connection-requests-desc":
          "Our specialized partner is directly integrated into your account for community creation and PMO. Conducting CAE requests and distribution keys.",
        "consuel-certificate-visa-requests-title":
          "Consuel Certificate Visa Requests",
        "consuel-certificate-visa-requests-desc":
          "Filing the SC144-A, SC144-B, or SC144-C, preparing the one-line electrical diagram, then submitting the Blue or Violet Conformity Certificate (for batteries).",
        "control-office-and-consuel-visa-title":
          "Control Office and Consuel Visa",
        "control-office-and-consuel-visa-desc":
          "Technical communication with accredited organizations and obtaining the DRE conformity report. Preparing the SC144, one-line electrical diagram, and submitting the Blue or Violet AC.",
        "sending-within-48-hours-on-a-large-scale-title":
          "Sending within 48 hours on a large scale",
        "sending-within-48-hours-on-a-large-scale-desc":
          "Our pioneering automation and robots generate documents and fill out online forms.",
        "real-time-dated-tracking-title": "Real-time dated tracking",
        "real-time-dated-tracking-desc":
          "Your secretariat can quickly initiate and then track the progress of procedures on the same software.",
        "processing-requests-for-additional-documents-title":
          "Processing requests for additional documents",
        "processing-requests-for-additional-documents-desc":
          "Our study office processes requests for additional documents to unblock the files.",
        "follow-ups-with-administrative-bodies-title":
          "Follow-ups with administrative bodies",
        "follow-ups-with-administrative-bodies-desc":
          "Our project managers follow up with administrative bodies to reduce processing times.",
        "edf-purchase-obligation-title": "EDF Purchase Obligation",
        "edf-purchase-obligation-desc":
          "Carrying out the procedure with EDF OA, automatic Affidavit or the S21 'ENR' Certificate with Carbon Footprint (for systems over 100 kWc).",
        "virtual-battery-procedure-title": "Virtual Battery Approach",
        "virtual-battery-procedure-desc":
          "Carrying out the procedure with one of the three virtual battery providers - MyLight150, Urban Solar Energy, JPME - for virtual storage.",
        "financing-profitability-report-title":
          "Financing Profitability Report",
        "financing-profitability-report-desc":
          "Analyze the financing of the photovoltaic investment based on energy yield, from an hourly kWh calculation.",
        "monthly-payment-and-savings-effort-calculation-title":
          "Monthly Payment and Savings Effort Calculation",
        "monthly-payment-and-savings-effort-calculation-desc":
          "Compare the financing of the photovoltaic investment, whether in cash or through a bank loan, integrating your OPEX and EBITDA.",
        "solar-subscription-title": "Solar Subscription",
        "solar-subscription-desc":
          "Our partner specializing in subscriptions is directly integrated into your account. Make solar subscription financing requests from the study stage.",
        "mobile-assistance-for-technical-visits-title":
          "Mobile Assistance for Technical Visits",
        "mobile-assistance-for-technical-visits-desc":
          "Your technical sales representatives can easily fill in client forms and upload photos and information while on the move.",
        "material-planning-title": "Material Planning",
        "material-planning-desc":
          "Automatic inventory lists of equipment available per site and per flow, for controlling material and orders.",
        "integrated-calendar-title": "Integrated Calendar",
        "integrated-calendar-desc":
          "Each team member has access, from their own account, to the company calendar for planning travels and installations. Add Google Calendar or Microsoft Outlook.",
        "sharing-sites-with-installers-title": "Sharing Sites with Installers",
        "sharing-sites-with-installers-desc":
          "Your technical documents can be shared directly from your account with your project partners, to facilitate construction, Consuel, and Control Bureau.",
        "client-relations-and-crm-title": "Client Relations and CRM",
        "client-relations-and-crm-desc":
          "Client assignments, comment space on client forms, file storage. Customizable automatic email notifications.",
        "team-access-and-roles-title": "Team Access and Roles",
        "team-access-and-roles-desc":
          "Sales, secretarial, and technical teams can each customize their interface. Managers have access to payments. Accounting has email access to invoices.",
        "integration-with-business-referrers-title":
          "Integration with Business Referrers",
        "integration-with-business-referrers-desc":
          "Business referrers only have access to their clients. Information visibility is customizable.",
        "customizable-dashboard-title": "Customizable Dashboard",
        "customizable-dashboard-desc":
          "Each team member can adjust their dashboard. Manage your sizing, studies, administrative procedures, and construction in one place.",
        "sales-cycle-tracking-and-reports-title":
          "Sales Cycle Tracking and Reports",
        "sales-cycle-tracking-and-reports-desc":
          "View key sales figures and activity in real-time. Our platform generates statistics of your projects. Receive automatic reports by email.",
        "data-export-title": "Data Export",
        "data-export-desc":
          "Need to analyze data in Excel? Need to secure the data? Export all tables and files in CSV format.",
        "automatic-as-built-files-title": "Automatic As-Built Files (DOE)",
        "automatic-as-built-files-desc":
          "Generate DOE reports in PDF or web format, shareable with clients and third parties for work acceptance reports and insurance audits.",
        "maintenance-contracts-title": "Maintenance Contracts",
        "maintenance-contracts-desc":
          "Help your clients schedule and pay for after-sales services (SAV) and maintenance contracts through online payment pages.",
        "white-label-title": "100% White Label",
        "white-label-desc":
          "Add your logo and main colors, buttons, and graphics. Customize the interfaces. Enhance your brand.",
        "white-label-client-portal-title": "White Label Client Portal",
        "white-label-client-portal-desc":
          "Invite your clients to an online space to view your study, sign your quote, and track the progress of their case. Your clients can enter information and documents.",
        "login-and-registration-pages-title":
          "Login and Registration Pages on Website",
        "login-and-registration-pages-desc":
          "Invite your clients to log into their white label client portal from your website.",
        "search-engine-optimization-title":
          "Search Engine Optimization and SEO",
        "search-engine-optimization-desc":
          "Fill in the customizable profile 'Our establishment' available on studies and in our directory.",
        "online-messaging-title": "Online Messaging",
        "online-messaging-desc":
          "Our team responds within minutes with written records.",
        "phone-support-title": "Phone Support",
        "phone-support-desc":
          "Our team is always available to assist you with your procedures.",
        "email-title": "Email",
        "email-desc":
          "Our team is available by email to facilitate your communications with third parties.",
        "video-conference-appointments-title": "Video Conference Appointments",
        "video-conference-appointments-desc":
          "Our team is here to listen and help you develop your follow-up together.",
        "file-transfer-title": "File Transfer",
        "file-transfer-desc":
          "Our IT teams assist you in migrating data and files to our system so you can manage operations.",
      },
    },
    DEVELOPER: {
      hero: {
        "icon-label": "Case Studies",
        "discover-solutions": "Discover Solutions",
        "book-demo": "Book a Demo",
        "name-orange": "Photovoltaic developer",
        "name-black": "looking to structure its growth",
        description:
          "Are you a company managing the development of SPV projects? Discover how to structure development and construction with external partners.",
      },
      works: {
        heading: "How it works",
        title:
          "Digital study office specializing in solar development in BT and HTA.",
        steps: {
          step1: {
            title: "Account opening",
            heading:
              "No commitment. Quick and free online registration. Then, complete the account with key company personnel.",
          },
          step2: {
            title: "File transfer",
            heading:
              "Our IT teams assist you in migrating data and files to our system to structure operations.",
          },
          step3: {
            title: "Starting Steering Committee",
            heading:
              "Service organization around detailed reports and bi-monthly meetings with a single contact person and project managers.",
          },
        },
      },
      "product-listing": {
        button: "Learn More",
        title: "Product Listing",
        description:
          "Discover our range of products designed to simplify your photovoltaic installation process.",
        "networking-title": "Networking",
        "networking-desc":
          "Discover potential clients directly from your account, without paying commissions to business introducers.",
        "project-management-assistance-title": "Project Management Assistance",
        "project-management-assistance-desc":
          "The project manager sets the price and materials. Benefit from the technical visit and electronic signature tools to accelerate your sales.",
        "3d-sizing-tool-title": "3D Sizing Tool",
        "3d-sizing-tool-desc":
          "We have integrated Aurora Solar to provide you with the most powerful and technically accurate photovoltaic yield solution.",
        "shading-masks-compliant-with-rge-audit-title":
          "Shading Masks Compliant with RGE Audit",
        "shading-masks-compliant-with-rge-audit-desc":
          "Opt for the precision of 0.10m LIDAR in 3D to perform sunlight assessments in kWh/m² throughout France.",
        "technical-design-pv-syst-title": "Technical Design with PV SYST",
        "technical-design-pv-syst-desc":
          "The electrical engineers from our study office carry out the design of inverters and Pnom, P50-P95 optimization for projects.",
        "quotes-with-integrated-materials-title":
          "Quotes with integrated materials",
        "quotes-with-integrated-materials-desc":
          "Prepare your quotes from a database with thousands of modules, inverters, enclosures, batteries.",
        "accounting-numbering-quotes-title": "Accounting numbering of quotes",
        "accounting-numbering-quotes-desc":
          "Also customize your colors, your general terms and conditions, technical sheets, VAT certificate, and much more for your quotes.",
        "legally-compliant-electronic-signatures-title":
          "Legally compliant electronic signatures",
        "legally-compliant-electronic-signatures-desc":
          "Write and have your quotes signed online, with your references and mentions. Access your quotes and documents in your account.",
        "accounting-invoices-title":
          "Accounting invoices for deposits and balances",
        "accounting-invoices-desc":
          "Define your deposits, manage your transactions, add your invoices, and much more.",
        "secure-payments-title":
          "Secure payments by bank transfer or credit card",
        "secure-payments-desc":
          "Receive your payments via simple payment pages, with several payment methods, integrated into your quotes and invoices.",
        "product-references-title":
          "10,000+ product references: modules, inverters, cabinets, batteries ...",
        "product-references-desc":
          "Choose the product model from our real-time updated database. Save your kits and equipment lists for reduced quote and procedure input.",
        "project-material-lists-title": "Project material lists",
        "project-material-lists-desc":
          "Automatic planning of product and equipment lists for photovoltaic installations.",
        "technical-datasheets-title":
          "Technical datasheets, Compliance Certificates, and Carbon Footprint Report",
        "technical-datasheets-desc":
          "Our database contains thousands of up-to-date documents for your procedures.",
        "professional-technical-docs-title":
          "Professional technical documentation",
        "professional-technical-docs-desc":
          "Automatically generate wiring diagrams, Strapping certificates, and Execution plans.",
        "material-ordering-title": "Material ordering",
        "material-ordering-desc":
          "Request quotes from manufacturers and distributors to find competitive prices online.",
        "urban-planning-authorization-title":
          "Urban Planning Authorization Requests",
        "urban-planning-authorization-requests-desc":
          "Filing the Preliminary Declaration or Building Permit for your photovoltaic installation with the relevant local authorities for approval at the town hall.",
        "communication-with-architects-title": "Communication with Architects",
        "communication-with-architects-desc":
          "Conducting PLU/RNU feasibility studies, preparing graphic documents, architect certification, and submission at the town hall as required by architect regulations.",
        "building-permit-expiry-title": "Building Permit Expiry",
        "building-permit-expiry-desc":
          "Filing the DOC, then conducting notary reports, EDDV, and DAACT for your photovoltaic installation with the relevant local authorities.",
        "preliminary-declarations-small-land-title":
          "Preliminary Declarations 'Small Land'",
        "preliminary-declarations-small-land-desc":
          "Conducting PLU/RNU feasibility studies, preparing the agricultural form, case-by-case study, and submitting the Preliminary Declaration at the town hall.",
        "low-or-medium-voltage-connection-requests-title":
          "Low or Medium Voltage Connection Requests",
        "low-or-medium-voltage-connection-requests-desc":
          "Obtaining the PTF and CACS-i contract, then commissioning your photovoltaic installation with the electrical network operator Enedis or local ELD operator.",
        "collective-self-consumption-connection-requests-title":
          "Collective Self-Consumption Connection Requests",
        "collective-self-consumption-connection-requests-desc":
          "Our specialized partner is directly integrated into your account for community creation and PMO. Conducting CAE requests and distribution keys.",
        "control-office-and-consuel-visa-title":
          "Control Office and Consuel Visa",
        "control-office-and-consuel-visa-desc":
          "Technical communication with accredited organizations and obtaining the DRE conformity report. Preparing the SC144, one-line electrical diagram, and submitting the Blue or Violet AC.",
        "sending-within-48-hours-title":
          "Sending within 48 hours on a large scale",
        "sending-within-48-hours-desc":
          "Our pioneering automation and robots generate documents and fill out online forms.",
        "real-time-dated-tracking-title": "Real-time dated tracking",
        "real-time-dated-tracking-desc":
          "Your secretariat can quickly initiate and then track the progress of procedures on the same software.",
        "processing-requests-for-additional-documents-title":
          "Processing requests for additional documents",
        "processing-requests-for-additional-documents-desc":
          "Our study office processes requests for additional documents to unblock the files.",
        "follow-ups-with-administrative-bodies-title":
          "Follow-ups with administrative bodies",
        "follow-ups-with-administrative-bodies-desc":
          "Our project managers follow up with administrative bodies to reduce processing times.",
        "edf-purchase-obligation-title": "EDF Purchase Obligation",
        "edf-purchase-obligation-desc":
          "Carrying out the procedure with EDF OA, automatic Affidavit or the S21 'ENR' Certificate with Carbon Footprint (for systems over 100 kWc).",
        "arpe-procedure-title": "ARPE Procedure",
        "arpe-procedure-desc":
          "Carrying out the procedure with an alternative buyer - Octopus Energie, Ekwateur, etc. - for PPE contracts and other purchase agreements.",
        "financing-profitability-report-title":
          "Financing Profitability Report",
        "financing-profitability-report-desc":
          "Analyze the financing of the photovoltaic investment based on energy yield, from an hourly kWh calculation.",
        "cost-price-buyout-profitability-calculation-title":
          "Cost Price, Buyout, and Profitability Calculation",
        "cost-price-buyout-profitability-calculation-desc":
          "Analyze the financing of the photovoltaic investment and the lease, integrating your OPEX and IRR (Internal Rate of Return).",
        "creation-and-management-of-spvs-title":
          "Creation and Management of SPVs",
        "creation-and-management-of-spvs-desc":
          "Your team organizes project portfolios by SPV directly from your account. Our project managers can create the SIRET numbers and assist with notaries.",
        "mobile-assistance-for-technical-visits-title":
          "Mobile Assistance for Technical Visits",
        "mobile-assistance-for-technical-visits-desc":
          "Your technical sales representatives can easily fill in client forms and upload photos and information while on the move.",
        "material-planning-title": "Material Planning",
        "material-planning-desc":
          "Automatic inventory lists of equipment available per site and per flow, for controlling material and orders.",
        "integrated-calendar-title": "Integrated Calendar",
        "integrated-calendar-desc":
          "Each team member has access, from their own account, to the company calendar for planning travels and installations. Add Google Calendar or Microsoft Outlook.",
        "sharing-sites-with-installers-title": "Sharing Sites with Installers",
        "sharing-sites-with-installers-desc":
          "Your technical documents can be shared directly from your account with your project partners, to facilitate construction, Consuel, and Control Bureau.",
        "sharing-files-with-third-parties-title":
          "Sharing Files with Third Parties",
        "sharing-files-with-third-parties-desc":
          "Your administrative documents can be shared directly from your account with third parties you authorize, for audits in the context of third-party investment.",
        "client-relations-and-crm-title": "Client Relations and CRM",
        "client-relations-and-crm-desc":
          "Client assignments, comment space on client forms, file storage. Customizable automatic email notifications.",
        "team-access-and-roles-title": "Team Access and Roles",
        "team-access-and-roles-desc":
          "Sales, secretarial, and technical teams can each customize their interface. Managers have access to payments. Accounting has email access to invoices.",
        "integration-with-business-referrers-title":
          "Integration with Business Referrers",
        "integration-with-business-referrers-desc":
          "Business referrers only have access to their clients. Information visibility is customizable.",
        "customizable-dashboard-title": "Customizable Dashboard",
        "customizable-dashboard-desc":
          "Each team member can adjust their dashboard. Manage your sizing, studies, administrative procedures, and construction in one place.",
        "sales-cycle-tracking-and-reports-title":
          "Sales Cycle Tracking and Reports",
        "sales-cycle-tracking-and-reports-desc":
          "View key sales figures and activity in real-time. Our platform generates statistics of your projects. Receive automatic reports by email.",
        "data-export-title": "Data Export",
        "data-export-desc":
          "Need to analyze data in Excel? Need to secure the data? Export all tables and files in CSV format.",
        "automatic-as-built-files-doe-title": "Automatic As-Built Files (DOE)",
        "automatic-as-built-files-doe-desc":
          "Generate DOE reports in PDF or web format, shareable with clients and third parties for work acceptance reports and insurance audits.",
        "maintenance-contracts-title": "Maintenance Contracts",
        "maintenance-contracts-desc":
          "Help your clients schedule and pay for after-sales services (SAV) and maintenance contracts through online payment pages.",
        "white-label-title": "100% White Label",
        "white-label-desc":
          "Add your logo and main colors, buttons, and graphics. Customize the interfaces. Enhance your brand.",
        "white-label-client-portal-title": "White Label Client Portal",
        "white-label-client-portal-desc":
          "Invite your clients to an online space to view your study, sign your quote, and track the progress of their case. Your clients can enter information and documents.",
        "login-and-registration-pages-on-website-title":
          "Login and Registration Pages on Website",
        "login-and-registration-pages-on-website-desc":
          "Invite your clients to log into their white label client portal from your website.",
        "search-engine-optimization-and-seo-title":
          "Search Engine Optimization and SEO",
        "search-engine-optimization-and-seo-desc":
          "Fill in the customizable profile 'Our establishment' available on studies and in our directory.",
        "online-messaging-title": "Online Messaging",
        "online-messaging-desc":
          "Our team responds within minutes with written records.",
        "phone-support-title": "Phone Support",
        "phone-support-desc":
          "Our team is always available to assist you with your procedures.",
        "email-title": "Email",
        "email-desc":
          "Our team is available by email to facilitate your communications with third parties.",
        "video-conference-appointments-title": "Video Conference Appointments",
        "video-conference-appointments-desc":
          "Our team is here to listen and help you develop your follow-up together.",
        "file-transfer-title": "File Transfer",
        "file-transfer-desc":
          "Our IT teams assist you in migrating data and files to our system so you can manage operations.",
        "bi-monthly-steering-committee-title": "Bi-monthly Steering Committee",
        "bi-monthly-steering-committee-desc":
          "Service organization around detailed reports and meetings every 15 days with a single point of contact and project managers.",
        "exclusive-access-title": "Exclusive Access",
        "exclusive-access-desc": "Your key teams are invited to join.",
      },
    },
    landing: {
      title: "All-in-One Solution for Your Solar Activity",
      description:
        "Discover how projetsolaire.com is used by our hundreds of clients to grow their business.",
      "discover-solutions": "Discover Solutions",
      "learn-more": "Learn More",
      "service-client-360": "360° Customer Service",
      "service-client-360-desc":
        "Stay in control with our multi-channel customer service available all year round.",
      heading: {
        artisan: "Solar Artisan",
        regional: "Local SME",
        national: "National Actor",
        franchise: "National / Franchises",
        developer: "Photovoltaic Developer",
        "plug-and-play": "National / DIY & Plug & Play",
      },
    },
  },
  header: {
    "buy-hardware": "Buy Hardware",
    functionalities: "Functionalities",
    solutions: "Solutions",
    marketplace: "Marketplace",
    contact: "Contact",
    connexion: "Sign in",
    dropdown: {
      functionalities: {
        title: "Functionalities",
        description: "All-in-one web, mobile and API platform designed for professionals to optimize every step of their installations. No subscription.",
        "secondary-button-label": "Browse solutions",
        "column2-title": "Free CRM-ERP",
        "column3-title": "Automations",
        services: {
          "instant-leads": "Instant leads",
          "customer-portal": "Customer portal",
          "mobile-app": "Mobile app",
          proposals: "Proposals",
          "customer-journeys": "Customer journeys",
          "calendar-team": "Calendar & Team",
          "activity-center": "Activity center",
          "partners-management": "Partners management",
          integrations: "Integrations",
        },
        automations: {
          "linky-data-request": "Linky data requests",
          "productibility-report": "Productibility report",
          "urbanism-feasibility": "Urbanism feasibility",
          "urbanism-authorization": "Urbanism authorization",
          "connection-request": "Connection request",
          "electrical-single-line": "Electrical single-line diagram",
          "call-for-tenders": "Call for tenders (AOS)",
          "consuel-sc144": "Consuel with SC144",
          "document-generation": "Document generation",
        },
      },
      solutions: {
        title: "Solutions",
        description: "All-in-one web, mobile and API platform designed for professionals to optimize every step of their installations. No subscription.",
        "secondary-button-label": "Testimonials",
        "column2-title": "Digital services",
        "column3-title": "Use cases",
        services: {
          "find-new-clients": "Find new clients",
          "sizing-layout": "Sizing and layout",
          "profitability-study": "Profitability study",
          "technical-visit-tool": "Technical visit tool",
          "administrative-procedures": "Administrative procedures",
          "material-stock-management": "Material stock management",
          "solar-leasing": "Solar leasing",
          "financing-third-party": "Financing and third-party investment",
          "maintenance-repowering": "Maintenance and repowering",
        },
        "use-cases": {
          artisan: "Solar Artisan",
          "pme-locale": "Local SME",
          national: "National Actor",
          "plug-and-play": "DIY Kits and Plug & Play",
          franchise: "Franchise Network",
          developer: "Photovoltaic Developer",
          "online-brand": "Online brand",
          "commercial-regie": "Commercial regie in subcontracting",
          "manufacturer-supplier": "Manufacturer or material supplier",
          "energy-supplier": "Energy supplier (EMS)",
        },
      },
      marketplace: {
        "win-projects": {
          title: "Win projects",
          description: "in project management assistance",
        },
        "publish-projects": {
          title: "Publish your projects",
          description: "as a client",
        },
      },
      contact: {
        "existing-client": {
          title: "Already a client?",
          description: "Contact our customer service now.",
        },
        "visit-help-center": "Visit Help Center",
        "customer-service": "Customer service",
        "first-steps": {
          title: "First steps?",
          description: "You will be guided in choosing the configuration best suited to your company's needs.",
        },
        "request-demo": "Request your demo",
      },
      "mobile-app": {
        title: "Construction site management on site",
        description: "Simplify communication on your construction sites with the <strong>projetsolaire Pro</strong> mobile app. Chat in real time with your team, upload your photos, and start procedures with one click, without paperwork.",
        "image-alt": "Mobile App Mockup",
        "google-play-alt": "Available on Google Play",
        "app-store-alt": "Available on the App Store",
      },
      "client-badge": "Already 1200 clients!",
      back: "Back",
    },
    "use-cases": {
      title: "Case Studies",
      description:
        "Discover how projetsolaire.com is used by our hundreds of clients to grow their business.",
      artisan: {
        name: "Solar Artisan",
        description: "Local photovoltaic installer.",
      },
      "pme-locale": {
        name: "Local SME",
        description:
          "Photovoltaic installer operating in multiple departments.",
      },
      national: {
        name: "National Actor",
        description:
          "An actor operating across France and handling many projects nationwide.",
      },
      "plug-and-play": {
        name: "DIY Kits and Plug & Play",
        description:
          "Brand offering a plug & play (solar kit) or DIY (Do It Yourself) solution across France.",
      },
      franchise: {
        name: "Franchise Network",
        description:
          "Company operating in franchise across the entire national territory, interested in the projects of the franchise network.",
      },
      developer: {
        name: "Photovoltaic Developer",
        description: "Company managing the development of projects in SPV.",
      },
    },
    products: {
      title: "Tailored Solutions",
      description:
        "Discover the all-in-one solution designed for professionals to optimize every step of the photovoltaic installation process.",
      sizing: {
        "product-name": "Solar Sizing",
        description: "3D layout with shadow masks.",
      },
      studies: {
        "product-name": "Photovoltaic Studies",
        description: "Hourly analysis over 25 years of sizing.",
      },
      qtv: {
        "product-name": "Quotations and App Technical Visit",
        description:
          "Checklist, quotations, electronic signature, invoices, online payments.",
      },
      procedures: {
        "product-name": "Administrative Procedures",
        description:
          "Urban Planning management, Enedis, Consuel, EDF OA, and more.",
      },
      stock: {
        "product-name": "Stocks and Materials",
        description: "Product references, material lists, orders.",
      },
      management: {
        "product-name": "Project Management",
        description:
          "Team access and roles, integrated calendar, sharing with third parties.",
      },
    },
  },
  "find-new-clients": {
    hero: {
      "discover-new-clients": {
        title: "Receive projects, send your quotes",
        paragraph:
          "Discover an innovative economic model for project management assistance. No business finder fees. No subcontracting.",
        "button-1": "Learn more",
        "button-2": "Get started",
      },
    },
    tenders: {
      title: "Projects are waiting for you",
      paragraph: "Apply easily and grow your business.",
      "button-1": "Current",
      "button-2": "Closed",
      "no-tenders": "No projects found",
      "load-more": "Load 10 more",
      loading: "Loading...",
      "know-more": "View Specifications",
      "estimated-power": "Estimated power",
      "selling-price": "Selling price",
      "on-roof": "On roof",
      beem: "Beem",
    },

    features: {
      title: "Find projects near you",
      paragraph:
        "Quickly access project opportunities matching your skills and location, all in a few clicks.",
      button: "Get started",
      "button-2": "Learn more",
      "search-local-area": {
        title: "Find projects online",
        paragraph:
          "The user defines the specifications that will best match the energy orientation of their solar project. The user is guided in their choice thanks to our technical-financial study of their photovoltaic installation. This includes the evaluation of solar radiation in kWh/m² as well as the hourly analysis of the on-site load curve.",
      },

      features: {
        feature1: {
          title: "Definition <br /> of needs",
          description:
            "The user defines the specifications adapted to the energy orientation of their solar project.",
        },
        feature2: {
          title: "Personalized <br /> support",
          description:
            "Support is offered through a tailor-made technical-financial study.",
        },
        feature3: {
          title: "Analysis of <br /> solar radiation",
          description:
            "The study includes an evaluation of solar radiation in kWh/m² on the project site.",
        },
        feature4: {
          title: "Study of the <br /> load curve",
          description:
            "An hourly analysis of the load curve helps to optimize the future installation.",
        },
      },
    },

    "key-features": {
      title: "Key features to simplify your experience",
      paragraph: "Manage your project from A to Z with ease.",
      button: "Get started",
      "button-2": "Learn more",
      features: {
        feature1: {
          title: "You choose the material",
          item1: "Read the user's specifications",
          item2: "Fill in your material",
          item3: "Validate feasibility during the technical visit",
        },
        feature2: {
          title: "Price your quote",
          item1: "Set your price and down payment freely",
          item2: "Describe your establishment",
          item3: "Only the selected craftsman contacts the user",
        },
        feature3: {
          title: "Receive turnkey projects",
          item1: "Automatic payment by bank transfer",
          item2: "Fees only if you get paid",
          item3: "Admin, financial, and insurance procedures included",
        },
      },
    },

    "how-it-works": {
      title: "How it works?",
      description:
        "A simple, transparent process designed for photovoltaic professionals.",
      steps: "The steps",

      cards: {
        card1: {
          title: "Activate your account",
          description:
            "To guarantee the trust of owners in the photovoltaic sector, you will need to submit your labels and legal documents.",
        },
        card2: {
          title: "Browse opportunities",
          description:
            "Submit your proposal free of charge. You choose the material; the price too. The user remains anonymous until they choose the project manager.",
        },
        card3: {
          title: "Carry out the technical visit",
          description:
            "Meet the user when they are ready to invest. The feasibility of the project will be validated during the mandatory on-site technical visit.",
        },
        card4: {
          title: "Submit your final quote",
          description:
            "Receive your income automatically upon electronic signature: the service is only billed upon payment of the deposit.",
        },
      },
    },

    "manage-construction-sites": {
      label: "The essentials",
      title: "Manage your projects with ease",
      description:
        "Benefit from an integrated platform with e-signature, secure payments, project planning, and automation. Our payment pages adapt to your invoicing for a smooth experience. Manage schedules, visits, and projects remotely from a simplified dashboard.",
      cta: "Get started",
    },

    pricing: {
      title: "Price per watt-peak",
      paragraph:
        "Fees are based on your prices per watt-peak. No cost if you do not generate revenue.",
      "on-card": {
        badge: "Reduce ancillary costs",
        title: "A triple-win pricing",
        paragraph:
          "A percentage of the amount excluding tax is deducted according to your income and the price per watt-peak. The more competitive your offer, the less you pay.",
        benefits: {
          benefit1: "Pay no sales commission.",
          benefit2: "Save time by avoiding premature travel.",
          benefit3:
            "No more administrative costs thanks to dematerialized management.",
        },
        "calculation-method": "Percentage calculation method",
        "price-unit": "€",
        "price-wc": "Wp",
        multiplier: "x 0.04",
        button: "Learn more",
        disclaimer: "Percentage deducted from the amount excluding tax.",
      },
    },

    cta: {
      title: "Simplify the management of your solar projects today",
      paragraph:
        "If you know how to send an email, you already know how to use our IT tool. Accelerate the growth of your business.",
      "button-1": "Get started",
      "button-2": "Learn more",
    },
  },
  "mobile-app": {
    ios: {
      title: "Coming Soon to iOS",
      description:
        "Stay tuned for the release of our exciting new mobile app. Be the first to experience the future of solar collaboration on your iPhone.",
      "android-text": "Or get it for Android",
      "mockup-alt": "App mockup",
      "google-play-alt": "Get it on Google Play",
      waitlist: {
        "email-placeholder": "Your email",
        "join-button": "Join the waitlist",
        "joined-button": "Joined!",
        "joining-button": "Joining...",
        "success-title": "Success",
        "success-message": "You have been added to the waitlist!",
        "error-title": "Error",
        "error-message": "Failed to join waitlist. Please try again.",
        "thank-you-message":
          "Thank you! We'll notify you when the app is available.",
      },
    },
  },
  "customer-support": {
    hero: {
      title: {
        before: "Branded",
        gradient: "online customer portals for customers",
        after: "",
      },
      subtitle:
        "Increase conversion rates and reduce back-and-forth with a professional, white-label portal that keeps your customers informed every step of the way.",
      button: {
        primary: "Get started for free",
        secondary: "Book a demo",
      },
    },
    why: {
      title: "Why Customer Portal?",
      subtitle: "Elevate your customer experience with a branded portal solution",
      features: {
        conversion: {
          title: "Increase conversion rates",
          description: "Professional portals build trust and confidence, helping close more deals.",
        },
        backAndForth: {
          title: "Reduce back-and-forth",
          description: "Centralize information and updates so customers always know what's happening.",
        },
        whiteLabel: {
          title: "Professional white-label experience",
          description: "Fully branded portals that match your company's look and feel.",
        },
        satisfaction: {
          title: "Better post-installation satisfaction",
          description: "Keep customers engaged and informed even after the installation is complete.",
        },
      },
    },
    "progress-tracking": {
      title: "Real-Time Progress Tracking",
      description: "You already have a solar opportunity. Residential, commercial, or industrial you define the scope, requirements, and time line.",
      features: {
        timeline: "Visual timeline showing every stage from quote to grid connection",
        "status-updates": "Automatic status updates keep customers informed without manual effort",
        "support-calls": "Reduce \"where is my installation?\" support calls significantly",
      },
    },
    "information-hub": {
      title: "Documents & information hub",
      features: {
        storage: "Centralized document storage for contracts, warranties, and manuals",
        access: "Customers can access important files anytime, anywhere",
        "version-control": "Upload once, share securely with version control",
      },
    },
    "post-installation-services": {
      title: "Quotes and Post-Installation Services",
      features: {
        "interactive-quotes": "Interactive quotes with clear pricing and approval workflows",
        "highlight-value": "Highlight post-installation value like warranties and maintenance",
        "long-term-relationships": "Build long-term relationships beyond the initial sale",
      },
    },
    platform: {
      title: "A customer portal. Three possibilities",
      subtitle: "Choose the layout adapted to your customer experience and your custom needs.",
      tabs: {
        "dashboard-modular-mode": "Dashboard / modular mode",
        "consecutive-flow": "Consecutive flow",
        "ems-grid-connection": "EMS / Grid Connection Flow",
      },
      features: {
        "dashboard-modular-mode": {
          "widget-based-layout": "Widget-based layout",
          "customizable-module-visibility": "Customizable module visibility",
          "quick-overview": "Quick overview of all project aspects",
        },
        "consecutive-flow": {
          "step-by-step-guided-journey": "Step-by-step guided journey",
          "linear-progression": "Linear progression through stages",
          "lead-nurturing": "Perfect for lead nurturing",
        },
        "ems-grid-connection": {
          "technical-milestone-tracking": "Technical milestone tracking",
          "regulatory-compliance-steps": "Regulatory compliance steps",
          "multi-stakeholder-coordination": "Multi-stakeholder coordination",
        },
      },
    },
    customization: {
      title: "Customisation and white-label",
      subtitle: "Make it truly yours with complete branding control",
      features: {
        "layout-selection": {
          title: "Layout selection",
          description: "Choose from dashboard, flow, or custom layouts",
        },
        "brand-colors-logo": {
          title: "Brand colors and logo",
          description: "Upload your logo and match your brand colors precisely",
        },
        "custom-copy": {
          title: "Custom copy",
          description: "Personalize all text, labels, and messaging",
        },
        "module-toggles": {
          title: "Module toggles",
          description: "Show or hide features based on your workflow",
        },
      },
    },
    integration: {
      title: "Website integration",
      subtitle: "Seamlessly embed or link to your customer portal.",
      methods: {
        "iframe-embed": {
          title: "iFrame embed",
          description: "Best for: Seamless integration where the portal appears as part of your website. Customers never leave your domain.",
        },
        "button-based-access": {
          title: "Button-Based access",
          description: "Best for: Simple linking from your site. Customers click to access their dedicated portal in a new tab or window.",
        },
      },
    },
    roles: {
      title: "For all types of customers",
      subtitle: "Solutions tailored to your specific solar and storage installation types.",
      types: {
        residential: {
          title: "Residential",
          description: "Perfect for homeowners who want to track their solar installation from quote to activation. Provide a professional experience that builds trust and reduces support calls.",
        },
        "commercial-industrial": {
          title: "Commercial & industrial",
          description: "Manage multi-stakeholder projects with document sharing, timeline tracking, and compliance milestone visibility for business clients.",
        },
        "utility-scale": {
          title: "Utility-scale",
          description: "Complex multi-stakeholder and grid connection workflows require sophisticated tracking. Keep all parties informed with detailed progress updates and technical documentation.",
        },
      },
    },
    cta: {
      title: "Ready to transform your customer experience?",
      description: "Join hundreds of solar installers who are closing more deals and delighting customers with branded portals.",
      button: {
        primary: "Get started for free",
        secondary: "Book a demo",
      },
    },
  },
};
